import React, { useState, useEffect, useRef, createContext, useMemo, useContext } from "react";
import { flushSync } from "react-dom";
import { createPortal } from "react-dom";
import {
  buildSectionedPrefill,
  buildSendMessageValidationSectionsFromResponses,
} from "./validationMessageUtils";
import "../../pages/Sidebar/sidebar.css";
import "../../assets/styles/application_det.css";
import "../../assets/styles/style.css";
import {
  useCreate,
  useGetOne,
  useGetList,
  Confirm,
  useGetIdentity,
  usePermissions,
  useRefresh,
} from "react-admin";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { GetdeleteddocumentlistList } from "../DocuploadTableComponent/GetDeletedDocumentList";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import Drawer from "@mui/material/Drawer";
import { yupResolver } from "@hookform/resolvers/yup";
import ApplicationHeader from "./ApplicationHeader";
import SelectInput from "./components/inputComponents/SelectInput";
import NameChangeModal from "./Modals/NameChangeModal";
import ProofOfNonEmploymentSection from "./ProofOfNonEmploymentIncome";
import BankStatements from "./BankStatements";
import OtherDocuments from "./OtherDocuments";
import ProofOfEmploymentIncome from "./ProofOfEmploymentIncome";
import pencilIcon from "../../assets/images/pencilIcon.svg";
import Box from "@mui/material/Box";
import { useNotify, useDataProvider, Resource } from "react-admin";
import moment from "moment";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useForm, FormProvider } from "react-hook-form";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import AlertDialogTable from "../DocuploadTableComponent/AlertDialogTable";
import { RootState } from "../../Store/store";
import { useDispatch, useSelector } from "react-redux";
import { notifyPopupBlocked, openWithPopupCheck } from "../../utils/popupWindow";
import VrReportOptionsMenu from "../common/VrReportOptionsMenu";
import PersonalDetailsAccordion from "./PersonalDetailsAccordion/PersonalDetailsAccordion";
import AddressAccordion from "./AddressAccordion/AddressAccordion";
import ApplicantDetailsAccordion from "./ApplicantDetailsAccordion/ApplicantDetailsAccordion";
import SsnAccordion from "./SsnAccordion/SsnAccordion";
import { setApplicationStatus } from "../../Store/Slice/usersSlice";
import img1 from "../../assets/images/view_docs_icon.svg";
import * as Yup from "yup";

import { BiSolidFileArchive, BiSolidFilePdf } from "react-icons/bi";
import { ENABLE_BULK_DOCUMENT_MOVE_DELETE, typesofUsers } from "../../config";
import { FaBook } from "react-icons/fa";
import { dataProvidersAts } from "../../dataproviders/DataProvidersAts";
import { toast } from "react-toastify";
import ShowNotesModal from "./Modals/ShowNotesModal";
import GrayStripeBar from "../common/GrayStripeBar";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import DateComponent from "../Ats/DateComponent";
import AuditlogModal from "./Modals/AuditlogModal";
import { useUserRole } from "../../ContextApi/UserRoleContext";
import SendEmailToApplicant from "../Ats/SendEmailToApplicant";
import ResendInvite from "../Ats/ResendInvite";
import ProofOfIdForm from "./ProofOfIdForm";
import { checkModuleAccess, isSuperAdmin } from "../../Functions/permissions";
import { FaRegNoteSticky } from "react-icons/fa6";
import ArgyleBankIncomeSection from "./ArgyleBankIncomeSection";
import ApplicantFooter from "./components/ApplicantFooter";
import { updateNewTagsForApplicantsUnconditional } from "../../utils/newTag";
import {
  getOrCreateVrReviewSession,
  getVrReviewSession,
} from "../../utils/vrReviewTelemetrySession";
import { isManualReviewerRole, isScreeningReportActionVisible } from "../../utils/screeningScore";
import ReportReprocessingIndicator from "../Ats/ReportReprocessingIndicator";
import { isExistingVrResultVisible } from "../../utils/atsApplicationStatus";
import { createIdempotencyKey } from "../../utils/idempotencyKey";
import {
  collectDocumentIdentifiers,
  hasDocumentIdentifiersChanged,
  hasPendingDocumentUpload,
  markPendingDocumentUpload,
  resetDocumentUploadTracking,
  resolveSubmitStatus,
  syncInitialDocumentIdentifiers,
} from "./documentSubmitUtils";
import RiskFlagAlert from "../common/RiskFlagAlert";
import {
  buildReportSectionTypes,
  buildRiskApplicantPayload,
  deriveBankRiskState,
  deriveRiskIdDocumentNumber,
  shouldReportIdFraudSection,
} from "./reportFraudUtils";
import { ReviewDoneFraudReportingContext } from "./reviewDoneFraudReporting";
import SubmissionOutlineNavigation from "./SubmissionOutlineNavigation";
import { DocumentMoveProvider, useDocumentMove } from "./documentMoveContext";
import { QuickLookProvider } from "../common/QuickLook/quickLookContext";
import { countUniqueDeletedDocuments } from "./deletedDocumentCount";
import {
  buildSubmissionOutlineItems,
  getApplicationStatusTooltip,
  getSourceNumber,
  mapApplicationStatusToOutlineStatus,
} from "./submissionOutlineModel";
import { useOpenPanel } from "../../hooks/useOpenPanel";
import { argyleVerboseLog } from "./argyleVerboseLogging";
import { isApplicantClassViewer } from "./applicantViewerRoles";
import { resolveSubscriberIdForStaffProfile } from "./subscriberIdForProfile";
import {
  BANK_INCOME_DEPOSIT_LINKING_FIELD,
  PAYROLL_LINKING_FIELD,
  applyDocumentSectionVisibility,
  isLinkingSettingEnabled,
  resolveApplicationProfileId,
  resolveApplicationProfileIdFromProperties,
  resolveSoleApplicationProfileId,
  selectApplicationProfileRecord,
  toLinkingSectionMode,
} from "../Settings/ApplicationProfileSettings/applicationProfileLinking";
import {
  shouldProtectApplicantLeave,
  useLeaveProtection,
} from "./useLeaveProtection";
import {
  ARGYLE_BANK_PENDING_HINT_PREFIX,
  ARGYLE_BANK_PENDING_HINT_TTL_MS,
} from "../../utils/argyleConfig";

interface RefObject {
  handleClickByRef: () => void;
  handleSubmitManual: () => void;
}

type DocumentAnalysisShowProps = {
  toggleDetails?: boolean;
  record?: any;
  index?: number,
  setForError?: any,
  tabValidation?: any[],
  totalApplicationCount?: number,
  isActiveTab?: boolean,
  onNavigatePrevTab?: (() => void) | null,
  onNavigateNextTab?: (() => void) | null,
};

const normalizeEmail = (value: any) =>
  typeof value === "string" ? value.trim().toLowerCase() : "";

const normalizeDigits = (value: any) =>
  String(value ?? "").replace(/\D/g, "").trim();

const normalizeRiskPhone = (value: any) => {
  const digits = normalizeDigits(value);
  if (digits.length === 11 && digits.startsWith("1")) {
    return digits.slice(1);
  }
  return digits;
};

const getFirstDefinedValue = (...values: any[]) =>
  values.find((value) => String(value ?? "").trim() !== "");

const hashIdentifierSeed = (seed: string) => {
  let hash = 0;
  for (let i = 0; i < seed.length; i += 1) {
    hash = (hash << 5) - hash + seed.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash).toString(36);
};

const mapRiskReportApplicationType = (applicationType: any, appType: any) => {
  if (applicationType === "Application Invite") {
    return "ATS";
  }
  if (applicationType === "Doc Upload") {
    return "VR";
  }
  if (appType === "1") {
    return "ATS";
  }
  if (appType === "2") {
    return "VR";
  }
  return "";
};

let activeOutlineBodyClassCount = 0;

const ARGYLE_VALIDATION_POLL_INTERVAL_MS = 10000;
const ARGYLE_FOLLOWUP_POLL_WINDOW_MS = 5 * 60 * 1000;

export const ApplicantContext = createContext<any>(null);

// Clears the bulk-move selection whenever this tab loses focus so that
// documents selected on one applicant tab don't linger on another.
const TabClearer: React.FC<{ isActiveTab: boolean }> = ({ isActiveTab }) => {
  const { clearSelection } = useDocumentMove();
  React.useEffect(() => {
    if (!isActiveTab) clearSelection();
  }, [isActiveTab, clearSelection]);
  return null;
};

type ApplicantInfoState = {
  trnId: unknown;
  applicantId: unknown;
  applicationStatusUpdatedOn: string | null;
};

// applicationStatusUpdatedOn doubles as the "last Review Done" date for the 4622
// per-document gate, so the post-submit optimistic bump (608, clears NEW badges)
// may only fire for the manual reviewer — the backend likewise skips the bump for
// non-review statuses (2/5). A subscriber submit forces Review Pending and must
// leave the reviewed date untouched (bug 4776).
export const applyReviewDoneTimestamp = (
  prev: ApplicantInfoState,
  userRole: unknown,
  nowIso: string
): ApplicantInfoState =>
  isManualReviewerRole(userRole)
    ? { ...prev, applicationStatusUpdatedOn: nowIso }
    : prev;

// Recompute applicant info from the current record, but never let a momentarily
// stale/absent record for the SAME applicant wipe the reviewed date we already
// hold — a falsy value flips every section to Review Pending at once (bug 4776).
export const resolveApplicantInfo = (
  prev: ApplicantInfoState,
  next: { trnId: unknown; applicantId: unknown; recordStatusUpdatedOn?: string | null }
): ApplicantInfoState => {
  const sameApplicant =
    prev.trnId === next.trnId && prev.applicantId === next.applicantId;
  return {
    trnId: next.trnId,
    applicantId: next.applicantId,
    applicationStatusUpdatedOn:
      next.recordStatusUpdatedOn ||
      (sameApplicant ? prev.applicationStatusUpdatedOn : null),
  };
};

const DocumentAnalysisContent = ({
  toggleDetails,
  record,
  totalApplicationCount = 1,
  index = 0,
  setForError = () => { },
  tabValidation = [],
  isActiveTab = true,
  onNavigatePrevTab = null,
  onNavigateNextTab = null,
}: DocumentAnalysisShowProps) => {
  const [childFormError1, setChildFormError1] = useState({});
  const [childFormError2, setChildFormError2] = useState({});
  const [childFormError3, setChildFormError3] = useState({});
  const [childFormError4, setChildFormError4] = useState({});
  const [childFormError5, setChildFormError5] = useState({});
  const openpanel = useOpenPanel();
  const reviewDoneFraudReporting = useContext(ReviewDoneFraudReportingContext);
  const isEmptyObject = (obj: any) => obj && Object.keys(obj).length === 0 && obj.constructor === Object;
  useEffect(() => {
    if (clickCount > 0) {
      setForError(
        (isEmptyObject(childFormError1) ? false : childFormError1) ||
        (isEmptyObject(childFormError2) ? false : childFormError2) ||
        (isEmptyObject(childFormError3) ? false : childFormError3) ||
        (isEmptyObject(childFormError5) ? false : childFormError5) ||
        (isEmptyObject(childFormError4) ? false : childFormError4)
      );
    }
    else {
      setForError(true);
    }

  }, [childFormError1, childFormError2, childFormError3, childFormError4]);

  const exportRef = useRef() as React.MutableRefObject<HTMLInputElement>;
  const navigation = useNavigate();
  const userTrnId = useSelector((state: RootState) => state.users.userTrnId);
  const trn_id = record?.Trnid || userTrnId;
  const applicant_id = record?.id;


  const [applicantInfo, setApplicantInfo] = useState({
    trnId: trn_id,
    applicantId: applicant_id,
    applicationStatusUpdatedOn: record?.ApplicationStatusUpdatedOn || null,
  });
  useEffect(() => {
    setApplicantInfo((prev) =>
      resolveApplicantInfo(prev, {
        trnId: trn_id,
        applicantId: applicant_id,
        recordStatusUpdatedOn: record?.ApplicationStatusUpdatedOn || null,
      })
    );
  }, [trn_id, applicant_id, record?.ApplicationStatusUpdatedOn]);
  const isOpeningForDashboard = useSelector(
    (state: RootState) => state.app.isOpeningForDashboard
  );
  const appHeaderRequired = useSelector(
    (state: RootState) => state.app.appHeader
  );

  const appFooterRequired = useSelector(
    (state: RootState) => state.app.appFooter
  );
  const [isLoadingViewApp, setIsLoading] = useState(false);
  const [vrReportMenuAnchorEl, setVrReportMenuAnchorEl] = useState<HTMLElement | null>(null);
  const isGuestCard = useSelector((state: RootState) => state.app.isGuestCard);
  const { role: userRoleContext } = useUserRole();
  const userRoleRedux = useSelector((state: RootState) => state.users.role);
  const userRole = userRoleContext || userRoleRedux;
  const poidRef = useRef<RefObject>(null);
  const poincome = useRef<RefObject>(null);
  const po_other_income = useRef<RefObject>(null);
  const possn = useRef<RefObject>(null);
  const po_banking = useRef<RefObject>(null);
  const [zipDownload, setZipDownload] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [grossMonthlyPay, setGrossMonthlyPay] = useState(0);
  const [argyleFollowupPollUntil, setArgyleFollowupPollUntil] = useState<number | null>(null);

  const handleGrossvalue = (value) => {
    setGrossMonthlyPay(value);
  };
  const schema = Yup.object({
    application_status: Yup.string().required("required").typeError("required"),
  });
  const schemaforNonDocuverusAdmin = Yup.object({
    application_status: Yup.string().nullable(),
  });
  const methods = useForm({
    resolver: yupResolver(userRole == 'Docuverus Super Admin' ? schema : schemaforNonDocuverusAdmin),
    mode: "onBlur",
  });
  const status1 = methods.getValues("application_status");
  const handleFormSubmitNext = async () => {
    setClickCount(preValue => preValue + 1);
    if (!isGuestCard) {
      let isValid_poidRef: any;
      let isValid_possn: any;
      let isValid_poincome: any;
      let isValid_po_other_income: any;
      let isValid_po_banking: any;

      if (
        sectionPermission?.data?.status[3].state == 2 ||
        sectionPermission?.data?.status[3].state == 1
      ) {
        isValid_poidRef =
          await poidRef?.current?.handleClickByRef();
        if (!isValid_poidRef) return;
      } else {
        isValid_poidRef = true;
      }

      if (
        sectionPermission?.data?.status[4].state == 2 ||
        sectionPermission?.data?.status[4].state == 1
      ) {
        isValid_possn =
          await possn?.current?.handleClickByRef();
        if (!isValid_possn) return;
      } else {
        isValid_possn = true;
      }

      if (employmentDocumentSection.visible) {
        isValid_poincome =
          await poincome?.current?.handleClickByRef();
        if (!isValid_poincome) return;
      } else {
        isValid_poincome = true;
      }
      if (
        sectionPermission?.data?.status[2].state == 2 ||
        sectionPermission?.data?.status[2].state == 1
      ) {
        isValid_po_other_income =
          await po_other_income?.current?.handleClickByRef();
        if (!isValid_po_other_income) return;
      } else {
        isValid_po_other_income = true;
      }
      if (bankingDocumentSection.visible) {
        isValid_po_banking =
          await po_banking?.current?.handleClickByRef();
        if (!isValid_po_banking) return;
      } else {
        isValid_po_banking = true;
      }

      if (
        isValid_poidRef &&
        isValid_poincome &&
        isValid_po_other_income &&
        isValid_po_banking &&
        isValid_possn
      ) {
        try {
          let callArray: any = [];
          if (proof_of_id_section)
            callArray.push(
              poidRef?.current?.handleSubmitManual()
            );
          if (proof_of_ssn_section) callArray.push(possn?.current?.handleSubmitManual(),)
          if (proof_of_income_section)
            callArray.push(
              poincome?.current?.handleSubmitManual()
            );
          if (other_income_section)
            callArray.push(
              po_other_income?.current?.handleSubmitManual()
            );
          if (bank_section)
            callArray.push(
              po_banking?.current?.handleSubmitManual()
            );
          await Promise.all(callArray);
        } catch (error) {
          notify(`Error updating sections`, {
            type: "warning",
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
          });
        } finally {
          handleApplicantSubmitNext(trn_id);
        }
      } else {
      }
    }
    if (isGuestCard) {
      let isValid_poidRef: any;
      isValid_poidRef =
        await poidRef?.current?.handleClickByRef();
      if (!isValid_poidRef) return;
      if (isValid_poidRef) {
        try {
          let callArray: any = [];
          if (proof_of_id_section)
            callArray.push(
              poidRef?.current?.handleSubmitManual()
            );
          await Promise.all(callArray);
        } catch (error) {
          notify(`Error updating sections`, {
            type: "warning",
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
          });
        } finally {
          handleApplicantSubmitNext(trn_id);
        }
      }
    }
  }
  const handleFormSubmit = async () => {
    setClickCount(preValue => preValue + 1);
    if (!isGuestCard) {
      let isValid_poidRef: any;
      let isValid_possn: any;
      let isValid_poincome: any;
      let isValid_po_other_income: any;
      let isValid_po_banking: any;

      if (
        sectionPermission?.data?.status[3].state == 2 ||
        sectionPermission?.data?.status[3].state == 1
      ) {
        isValid_poidRef =
          await poidRef?.current?.handleClickByRef();
        if (!isValid_poidRef) return;
      } else {
        isValid_poidRef = true;
      }

      if (
        sectionPermission?.data?.status[4].state == 2 ||
        sectionPermission?.data?.status[4].state == 1
      ) {
        isValid_possn =
          await possn?.current?.handleClickByRef();
        if (!isValid_possn) return;
      } else {
        isValid_possn = true;
      }

      if (employmentDocumentSection.visible) {
        isValid_poincome =
          await poincome?.current?.handleClickByRef();
        if (!isValid_poincome) return;
      } else {
        isValid_poincome = true;
      }
      if (
        sectionPermission?.data?.status[2].state == 2 ||
        sectionPermission?.data?.status[2].state == 1
      ) {
        isValid_po_other_income =
          await po_other_income?.current?.handleClickByRef();
        if (!isValid_po_other_income) return;
      } else {
        isValid_po_other_income = true;
      }
      if (bankingDocumentSection.visible) {
        isValid_po_banking =
          await po_banking?.current?.handleClickByRef();
        if (!isValid_po_banking) return;
      } else {
        isValid_po_banking = true;
      }

      if (
        isValid_poidRef &&
        isValid_possn &&
        isValid_poincome &&
        isValid_po_other_income &&
        isValid_po_banking
      ) {
        try {
          let callArray: any = [];
          if (proof_of_id_section)
            callArray.push(
              poidRef?.current?.handleSubmitManual()
            );
          if (proof_of_ssn_section) callArray.push(possn?.current?.handleSubmitManual(),)
          if (proof_of_income_section)
            callArray.push(
              poincome?.current?.handleSubmitManual()
            );
          if (other_income_section)
            callArray.push(
              po_other_income?.current?.handleSubmitManual()
            );
          if (bank_section)
            callArray.push(
              po_banking?.current?.handleSubmitManual()
            );
          await Promise.all(callArray);
        } catch (error) {
          notify(`Error updating sections`, {
            type: "warning",
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
          });
        } finally {
          handleApplicantSubmit(trn_id);
        }
      } else {
      }
    }
    if (isGuestCard) {
      let isValid_poidRef: any;
      isValid_poidRef =
        await poidRef?.current?.handleClickByRef();
      if (!isValid_poidRef) return;
      if (isValid_poidRef) {
        try {
          let callArray: any = [];
          if (proof_of_id_section)
            callArray.push(
              poidRef?.current?.handleSubmitManual()
            );
          await Promise.all(callArray);
        } catch (error) {
          notify(`Error updating sections`, {
            type: "warning",
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
          });
        } finally {
          handleApplicantSubmit(trn_id);
        }
      }
    }
  }
  const [noteText, setNoteText] = useState("");
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [deleteddocs, setdeleteddocs] = useState(false);
  const allButLastAreTrue = tabValidation?.slice(0, -1).every(value => value === true);
  const handleopendeleteddocs = () => {
    setdeleteddocs(true);
  };
  const handleclosedeleteddocs = React.useCallback(() => {
    setdeleteddocs(false);
  }, []);
  const DeletedDocsList = React.useCallback(
    () => (
      <GetdeleteddocumentlistList
        trn_id={trn_id}
        onSourceFull={handleclosedeleteddocs}
      />
    ),
    [trn_id, handleclosedeleteddocs]
  );
  const dispatch = useDispatch();
  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  // get application type
  const { id, applicationId, appType, roletype, office_id } = useParams();
  const location = useLocation();
  const getlocalStorageItem: any = localStorage.getItem(
    "stateRecord" + applicationId
  );
  const locationState = getlocalStorageItem ? JSON.parse(getlocalStorageItem) : null;
  const data = location.state || locationState;
  const telemetryApplicationNumber = record?.AppID || applicationId || data?.id;
  const telemetryApplicantId = record?.id || applicant_id || data?.ApplicantID;
  const notify = useNotify();
  const dataProvider = useDataProvider();

  const [applicantDetails, setApplicantDetails] = React.useState<any>({
    application_id: null,
    application_status: null,
    creataed_on: null,
    email: null,
    first_name: null,
    last_name: null,
    middle_name: null,
    mobile: null,
    country_code: null,
    office_property_city: null,
    office_property_name: null,
  });



  const [subscriberData, setSubscriberData] = useState({
    CompanyName: null,
    StreetAddress: null,
    State: null,
    City: null,
    Email: null,
    NumberOfCoApplicant: null,
    LookBackPeriod: null,
  });

  const [isThirdPartyIntegration, setIsThirdPartyIntegration] = useState(false);
  const reviewOpenedAtRef = React.useRef<number | null>(null);
  const hasEmittedOpenRef = React.useRef<string | null>(null);

  // ADO 4853: reused across repeated Submit clicks for the same VR + same
  // requested disposition, so a reviewer retrying after a failed capture
  // resumes the same backend row/result instead of inserting a new
  // snapshot. Cleared on success (see clearSubmitIdempotencyKey below) —
  // for most reviewer roles, resolveSubmitStatus forces the same disposition
  // (e.g. Review Pending) on every submit, so a cache keyed on (trnId, status)
  // alone can't tell "retry of this attempt" apart from "a later, genuinely
  // new submission"; only clearing on success (rather than never) lets a
  // later real submission get its own key. A double-click / stale-form
  // resubmit right after success doesn't need the key kept around either:
  // the Submit control is disabled while the request is in flight, so it
  // can't race a second request in under it.
  const pendingSubmitIdempotencyKeyRef = React.useRef<{ trnId: unknown; status: unknown; key: string } | null>(null);
  const getSubmitIdempotencyKey = (currentTrnId: unknown, currentStatus: unknown) => {
    const pending = pendingSubmitIdempotencyKeyRef.current;
    if (pending && pending.trnId === currentTrnId && pending.status === currentStatus) {
      return pending.key;
    }
    const key = createIdempotencyKey();
    pendingSubmitIdempotencyKeyRef.current = { trnId: currentTrnId, status: currentStatus, key };
    return key;
  };
  const clearSubmitIdempotencyKey = () => {
    pendingSubmitIdempotencyKeyRef.current = null;
  };

  useEffect(() => {
    if (!telemetryApplicationNumber) return;
    if (isActiveTab === false) return;
    if (
      userRole !== typesofUsers.docuverusSuperAdmin &&
      userRole !== typesofUsers.docuverusAdmin &&
      userRole !== typesofUsers.superAdmin
    ) return;

    if (hasEmittedOpenRef.current === telemetryApplicationNumber) return;
    hasEmittedOpenRef.current = telemetryApplicationNumber;

    const eventType = appType === "1" ? "ats_open_from_dashboard" : "vr_open_from_dashboard";
    const session = getOrCreateVrReviewSession(telemetryApplicationNumber);
    dataProvider.create("telemetryEvent", {
      data: {
        eventType,
        applicationNumber: telemetryApplicationNumber,
        applicantId: telemetryApplicantId || null,
        subscriberId: record?.SubscriberID || null,
        trn_id: trn_id || null,
        session,
        source: "dashboard",
      },
    }).catch(() => { });
    const openedAt = Date.now()
    reviewOpenedAtRef.current = openedAt;
    sessionStorage.setItem(
      `review_${telemetryApplicationNumber}_opened`,
      openedAt.toString()
    );
    openpanel.track("application_opened", {
      applicationNumber: telemetryApplicationNumber,
      applicantId: telemetryApplicantId || null,
      subscriberId: record?.SubscriberID || null,
      trnId: trn_id || null,
      applicationType: appType === "1" ? "ATS" : "VR",
    });
  }, [telemetryApplicationNumber, userRole, appType]);

  useEffect(() => {
    if (applicantDetails?.archived == true && userRole == "applicant") {
      navigation("/admin/archieved", { replace: true });
    }
  }, [applicantDetails]);
  const { data: proofOfIdsData, isLoading: proofOfIdsDataLoading } = useGetOne(
    "proofOfIdsData",
    { id: trn_id },
    { enabled: trn_id != null, refetchOnWindowFocus: false }
  );
  const { data: ssnIdentificationData, isLoading: ssnIdentificationDataLoading } = useGetOne(
    "ssnGetidentification",
    { id: trn_id },
    { enabled: trn_id != null, refetchOnWindowFocus: false }
  );



  const IncomeAPIResponse = useGetOne(
    "income",
    { id: trn_id },
    { enabled: !isGuestCard && trn_id != null, refetchOnWindowFocus: false }
  );



  const { data: meta_d_response } = useGetOne('getMetaData', { id: 3, meta: { trn_id } }, { refetchOnWindowFocus: false, staleTime: 5 })

  const isDocUploadApp =
    appType === "2" ||
    applicantDetails?.application_type === "Doc Upload";
  const shouldHandleApplicantStatusOnSubmitOnly =
    isDocUploadApp && userRole === "applicant";

  const { data: validationCheck, isSuccess } = useGetOne("getBankValidationCheck", { id: trn_id }, { enabled: trn_id != null, refetchOnWindowFocus: false });
  // Same availability source the legacy Move dialog uses: sections whose value
  // is null cannot receive moved documents for this applicant. Only fetched
  // for the role that can actually use bulk move (Docuverus Super Admin) on
  // the active tab — every other viewer never needs it, and this component
  // mounts once per applicant tab, so fetching it unconditionally issued one
  // extra request per tab per page load for users who can't use the feature.
  const { data: sectionAvailabilityData } = useGetOne(
    "getsectionavailable",
    { id: applicant_id },
    {
      enabled:
        applicant_id != null &&
        isActiveTab &&
        userRole === typesofUsers.docuverusSuperAdmin,
      refetchOnWindowFocus: false,
    }
  );
  const { data: validationCheckForIncome } = useGetOne("getEmployerValidationCheck", { id: trn_id }, { enabled: trn_id != null, refetchOnWindowFocus: true });
  const { data: validationCheckForID } = useGetOne("getIDValidationCheck", { id: trn_id }, { enabled: trn_id != null, refetchOnWindowFocus: false });
  const {
    data: plaidBankIncomeEnabledData,
    isLoading: plaidBankIncomeEnabledLoading,
    isError: plaidBankIncomeEnabledError,
    refetch: refetchPlaidBankIncomeEnabled,
  } = useGetOne(
    "plaid/plaidBankIncomeEnabled",
    { id: trn_id },
    { enabled: trn_id != null, refetchOnWindowFocus: true }
  );
  const plaidBankIncomeEnabled = Boolean(plaidBankIncomeEnabledData?.enabled);
  const {
    data: validationCheckForPlaidBankIncome,
    isLoading: plaidBankIncomeValidationLoading,
    isError: plaidBankIncomeValidationError,
    refetch: refetchPlaidBankIncomeValidation,
  } = useGetOne(
    "plaid/bankIncomeValidationCheck",
    { id: trn_id },
    {
      enabled: trn_id != null,
      refetchOnWindowFocus: true,
    }
  );
  const {
    data: argyleBankIncomeEnabledData,
    isLoading: argyleBankIncomeEnabledLoading,
    isError: argyleBankIncomeEnabledError,
    refetch: refetchArgyleBankIncomeEnabled,
  } = useGetOne(
    "argyle/argyleBankIncomeEnabled",
    { id: trn_id },
    { enabled: trn_id != null, refetchOnWindowFocus: true }
  );
  const argyleBankIncomeEnabled = Boolean(argyleBankIncomeEnabledData?.enabled);
  const {
    data: validationCheckForArgyleBankIncome,
    isLoading: argyleBankIncomeValidationLoading,
    isError: argyleBankIncomeValidationError,
    refetch: refetchArgyleBankIncomeValidation,
  } = useGetOne(
    "argyleBankIncomeValidationCheck",
    { id: trn_id },
    {
      enabled: trn_id != null,
      refetchOnWindowFocus: true,
      refetchInterval: (data: any) => {
        const status = String(data?.overallStatus || "").toLowerCase();
        const failureCode = String(data?.failure?.code || "").toLowerCase();
        if (status === "pending") return 15000;
        if (status !== "none" && !(status === "failed" && failureCode === "client_exit")) {
          return false;
        }
        if (typeof window === "undefined" || !trn_id) return false;
        const key = `${ARGYLE_BANK_PENDING_HINT_PREFIX}${trn_id}`;
        const raw = sessionStorage.getItem(key);
        const ts = Number(raw);
        if (!raw || !Number.isFinite(ts)) return false;
        return Date.now() - ts <= ARGYLE_BANK_PENDING_HINT_TTL_MS ? 15000 : false;
      },
      refetchIntervalInBackground: true,
    }
  );
  const argyleBankPendingHintActive = useMemo(() => {
    const status = String(validationCheckForArgyleBankIncome?.overallStatus || "").toLowerCase();
    if (status === "linked" || status === "failed" || status === "linked_no_data") return false;
    if (typeof window === "undefined" || !trn_id) return false;
    const key = `${ARGYLE_BANK_PENDING_HINT_PREFIX}${trn_id}`;
    const raw = sessionStorage.getItem(key);
    const ts = Number(raw);
    if (!raw || !Number.isFinite(ts)) return false;
    return Date.now() - ts <= ARGYLE_BANK_PENDING_HINT_TTL_MS;
  }, [trn_id, validationCheckForArgyleBankIncome?.overallStatus]);
  const { data: plaidPayrollEnabledData } = useGetOne("plaid/plaidPayrollIncomeEnabled", { id: trn_id }, { enabled: trn_id != null && isDocUploadApp, refetchOnWindowFocus: true });
  const plaidPayrollEnabled = Boolean(plaidPayrollEnabledData?.enabled);
  const { data: argylePayrollEnabledData } = useGetOne("argyle/argylePayrollIncomeEnabled", { id: trn_id }, { enabled: trn_id != null && isDocUploadApp, refetchOnWindowFocus: true });
  const argylePayrollEnabled = Boolean(argylePayrollEnabledData?.enabled);
  // Combined flag — true when EITHER provider is enabled for this applicant's
  // scope. Gates the "choose between upload vs connect payroll" affordance.
  // The plaid-specific boolean is still used below to gate plaid-specific data
  // fetches; don't conflate the two.
  const anyPayrollProviderEnabled = plaidPayrollEnabled || argylePayrollEnabled;
  // The Plaid payrollIncomeValidationCheck endpoint reads
  // trnApplicationEmployerPayrollLink provider-agnostically for pending/valid
  // source status, so it also reflects Argyle-linked rows. Keep this fetch
  // running for doc-upload apps regardless of current provider flags so we can
  // still hydrate previously linked payroll sources.
  const { data: validationCheckForPlaidPayrollIncome, isLoading: plaidPayrollLoading, isError: plaidPayrollError } = useGetOne(
    "plaidPayrollIncomeValidationCheck",
    { id: trn_id },
    {
      enabled: trn_id != null && isDocUploadApp,
      refetchOnWindowFocus: true,
      refetchInterval: (data: any) => (data?.pending ? 15000 : false),
      refetchIntervalInBackground: true,
    }
  );
  const payrollPending = Boolean(validationCheckForPlaidPayrollIncome?.pending);
  useEffect(() => {
    argyleVerboseLog("docAnalysis.payrollPending.state", {
      trn_id,
      payrollPending,
      pendingSourceIds: validationCheckForPlaidPayrollIncome?.pendingSourceIds || [],
    });
  }, [trn_id, payrollPending, validationCheckForPlaidPayrollIncome?.pendingSourceIds]);

  const hasLinkedOrPendingPayrollSource = useMemo(() => {
    const statuses = validationCheckForPlaidPayrollIncome?.payrollSourceStatuses;
    if (!Array.isArray(statuses)) return false;
    return statuses.some((status: any) => {
      const normalizedStatus = String(status?.status || "").trim().toLowerCase();
      return normalizedStatus === "valid" || normalizedStatus === "pending";
    });
  }, [validationCheckForPlaidPayrollIncome?.payrollSourceStatuses]);

  // Argyle validation-check fetch. Backend returns {responses: [...]}, each
  // response carrying `normalized` — an array of employer objects in the
  // exact shape Plaid's `payrollEmployers` uses (plaid_item_id=null,
  // argyle_account_id populated). We flatten and merge below so downstream
  // components render Argyle-linked sources transparently.
  const {
    data: validationCheckForArgylePayrollIncome,
    refetch: refetchArgylePayrollIncome,
    isLoading: argylePayrollLoading,
  } = useGetOne(
    "argylePayrollIncomeValidationCheck",
    { id: trn_id },
    {
      enabled:
        trn_id != null &&
        isDocUploadApp &&
        (argylePayrollEnabled || hasLinkedOrPendingPayrollSource),
      refetchOnWindowFocus: true,
      refetchInterval: () => {
        const inFollowupWindow = Boolean(
          argyleFollowupPollUntil &&
            Date.now() < argyleFollowupPollUntil &&
            (argylePayrollEmployers.length === 0 ||
              validationCheckForArgylePayrollIncome?.identitySnapshotAvailable === false)
        );
        return payrollPending || inFollowupWindow
          ? ARGYLE_VALIDATION_POLL_INTERVAL_MS
          : false;
      },
      refetchIntervalInBackground: true,
    }
  );
  const argylePayrollEmployers = useMemo(() => {
    const responses = validationCheckForArgylePayrollIncome?.responses;
    if (!Array.isArray(responses)) return [];
    const flat: any[] = [];
    responses.forEach((response: any) => {
      const normalized = response?.normalized;
      if (Array.isArray(normalized)) {
        normalized.forEach((employer: any) =>
          flat.push({ ...employer, payroll_provider: "argyle" })
        );
      }
    });
    return flat;
  }, [validationCheckForArgylePayrollIncome?.responses]);
  // Once Plaid's pending flag flips true -> false, the Argyle webhook flow
  // has almost certainly landed (they share the trnApplicationEmployerPayrollLink
  // row that gates pending). Refetch Argyle's blob list so linked rows render
  // in the same render pass that clears the spinner.
  const plaidPendingPrevRef = useRef(false);
  useEffect(() => {
    const nextPending = Boolean(validationCheckForPlaidPayrollIncome?.pending);
    if (plaidPendingPrevRef.current && !nextPending) {
      argyleVerboseLog("docAnalysis.argyleRefetch.onPendingFlip", { trn_id, nextPending });
      refetchArgylePayrollIncome?.();
      setArgyleFollowupPollUntil(Date.now() + ARGYLE_FOLLOWUP_POLL_WINDOW_MS);
    }
    plaidPendingPrevRef.current = nextPending;
  }, [validationCheckForPlaidPayrollIncome?.pending, refetchArgylePayrollIncome]);

  useEffect(() => {
    const identitySnapshotAvailable =
      validationCheckForArgylePayrollIncome?.identitySnapshotAvailable;
    if (argylePayrollEmployers.length === 0) return;

    if (identitySnapshotAvailable === false) {
      if (!argyleFollowupPollUntil) {
        argyleVerboseLog("docAnalysis.argyleFollowupPoll.awaitingIdentity", { trn_id });
        setArgyleFollowupPollUntil(Date.now() + ARGYLE_FOLLOWUP_POLL_WINDOW_MS);
      }
      return;
    }

    if (argyleFollowupPollUntil) {
      argyleVerboseLog("docAnalysis.argyleFollowupPoll.completed", { trn_id });
      setArgyleFollowupPollUntil(null);
    }
  }, [
    argylePayrollEmployers.length,
    argyleFollowupPollUntil,
    trn_id,
    validationCheckForArgylePayrollIncome?.identitySnapshotAvailable,
  ]);

  const plaidPayrollEmployersArray = Array.isArray(
    validationCheckForPlaidPayrollIncome?.payrollEmployers
  )
    ? validationCheckForPlaidPayrollIncome?.payrollEmployers
    : [];
  const payrollEmployers = [...plaidPayrollEmployersArray, ...argylePayrollEmployers];
  const payrollEmployerNameBySource = React.useMemo(() => {
    const labelBySource = new Map<number, string>();
    payrollEmployers.forEach((employer: any) => {
      const sourceId = getSourceNumber(
        employer?.source_id ?? employer?.sourceId,
        0
      );
      if (!sourceId) return;
      const employerName =
        typeof employer?.employer_name === "string"
          ? employer.employer_name.trim()
          : "";
      if (!employerName) return;
      if (!labelBySource.has(sourceId)) {
        labelBySource.set(sourceId, employerName);
      }
    });
    return labelBySource;
  }, [payrollEmployers]);
  const payrollEmployersHash = React.useMemo(() => {
    try {
      return JSON.stringify(payrollEmployers);
    } catch (error) {
      return String(payrollEmployers.length);
    }
  }, [payrollEmployers]);
  const payrollToastHydratedRef = useRef(false);
  const prevPayrollPendingRef = useRef(false);
  const prevPayrollEmployersHashRef = useRef("");
  useEffect(() => {
    payrollToastHydratedRef.current = false;
    prevPayrollPendingRef.current = false;
    prevPayrollEmployersHashRef.current = "";
  }, [trn_id]);

  useEffect(() => {
    if (validationCheckForPlaidPayrollIncome === undefined) {
      return;
    }

    if (!payrollToastHydratedRef.current) {
      payrollToastHydratedRef.current = true;
      prevPayrollPendingRef.current = payrollPending;
      prevPayrollEmployersHashRef.current = payrollEmployersHash;
      return;
    }

    const pendingToNotPending = prevPayrollPendingRef.current && !payrollPending;
    const payrollUpdated =
      !payrollPending &&
      prevPayrollEmployersHashRef.current !== payrollEmployersHash;

    if (pendingToNotPending || payrollUpdated) {
      notify("Your payroll data has been updated.", { type: "info" });
    }

    prevPayrollPendingRef.current = payrollPending;
    prevPayrollEmployersHashRef.current = payrollEmployersHash;
  }, [
    notify,
    payrollEmployersHash,
    payrollPending,
    validationCheckForPlaidPayrollIncome,
  ]);
  const { data: bankData, isLoading: bankDocLoading, isFetching } = useGetOne(
    "bankDoc",
    { id: trn_id },
    { enabled: !isGuestCard && trn_id != null, refetchOnWindowFocus: false }
  );
  const { data: otherDocumentsData, isLoading: otherDocumentsLoading } = useGetOne(
    "otherDoc",
    { id: trn_id },
    { enabled: trn_id != null, refetchOnWindowFocus: false }
  );


  const { data: otherIncomeData, isLoading: otherIncomeDocLoding } = useGetOne(
    "otherIncomeDoc",
    { id: trn_id },
    { enabled: !isGuestCard && trn_id != null, refetchOnWindowFocus: false }
  );
  const sectionPermission = useGetOne(
    "getSubscriberProfileSection_new",
    { id: trn_id },
    { refetchOnWindowFocus: false, enabled: !!trn_id }
  );

  const {
    data: getSubscriberConfigurations,
    isLoading: isLoadingSubscriberConfigurations,
  } = useGetOne(
    "get-subscriber-configurations",
    {
      id: id,
    },
    {
      refetchOnWindowFocus: false,
      enabled: id ? true : false,
    }
  );

  const {
    data: deletedDocuments,
  } = useGetList(
    "deletedDocument",
    {
      pagination: { page: 1, perPage: 100 },
      sort: { field: "id", order: "DESC" },
      filter: { trn_id },
    },
    {
      enabled: Boolean(trn_id) && isActiveTab,
      refetchOnWindowFocus: false,
    }
  );

  const {
    data: applicantData,
    isLoading: loading,
    refetch,
  } = useGetOne(
    "getApplicantDetails",
    { id: trn_id },
    {
      onSuccess: (value) => {
        setApplicantDetails(value?.Application_details);
        setSubscriberData(value?.data?.subscriber_details);
        dispatch(
          setApplicationStatus(value?.Application_details?.application_status)
        ); // storing a application_status for global used
      },
      onError: (err) => {
        notify(`Error: ${err}`, {
          type: "warning",
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
      },
      refetchOnWindowFocus: false,
      enabled: trn_id != null,
    }
  );

  const appStatus = applicantData?.Application_details?.application_status;
  const deletedDocCount = countUniqueDeletedDocuments(deletedDocuments);
  const idSectionData = proofOfIdsData?.identification_data || {};
  const ssnSectionData =
    ssnIdentificationData?.data?.ssn_data || proofOfIdsData?.ssn_data || {};
  const hasIdSectionDocumentContext =
    idSectionData?.availableToUpload_id === "Yes" &&
    Boolean(
      idSectionData?.file ||
      idSectionData?.backfile ||
      idSectionData?.application_document_id
    );
  const hasSsnSectionDocumentContext =
    ssnSectionData?.availableToUpload_ssn === "Yes" &&
    Boolean(
      ssnSectionData?.file ||
      ssnSectionData?.file_image ||
      ssnSectionData?.application_document_id
    );
  const idSectionSocrStatus = Number(
    idSectionData?.ManualSOCRstatus ??
    validationCheckForID?.SOCRStatus
  );
  const ssnSectionSocrStatus = Number(
    ssnIdentificationData?.data?.ssn_data?.manualsocr ??
    ssnIdentificationData?.data?.ssn_data?.calculatedscocr
  );
  const isIdSectionUnverifiable =
    hasIdSectionDocumentContext && Number(idSectionSocrStatus) === 2;
  const isSsnSectionUnverifiable =
    (hasSsnSectionDocumentContext ||
      ssnSectionData?.availableToUpload_ssn === "Yes") &&
    Number(ssnSectionSocrStatus) === 2;
  const employerSources = IncomeAPIResponse?.data?.employment_details?.employer || [];
  const getEmployerSourceStatus = (sourceIndex: number) => {
    const incomeSourceKey = `Source_${sourceIndex + 1}`;
    const validationSourceKey = `source_${sourceIndex + 1}`;
    const incomeStatus =
      IncomeAPIResponse?.data?.employment_details?.SOCRstatus?.[incomeSourceKey];
    const validationStatus =
      validationCheckForIncome?.other_check?.[validationSourceKey]?.SOCRStatus;
    return incomeStatus ?? validationStatus;
  };
  const hasEmployerDocumentContext = employerSources.some(
    (employer) =>
      employer?.availableToUpload === "Yes" &&
      ((employer?.files && employer?.files?.length > 0) ||
        Number(employer?.fileCount) > 0)
  );
  const employerSourceSocrStatuses = employerSources
    .map((employer, index) => {
      const hasEmployerSourceDocuments =
        employer?.availableToUpload === "Yes" &&
        ((employer?.files && employer?.files?.length > 0) ||
          Number(employer?.fileCount) > 0);
      if (!hasEmployerSourceDocuments) {
        return null;
      }
      return getEmployerSourceStatus(index);
    })
    .filter((status) => status !== null && status !== undefined);
  const isEmployerSectionUnverifiable =
    hasEmployerDocumentContext &&
    employerSourceSocrStatuses.some((status) => Number(status) === 2);
  const plaidBankIncomeSources = Array.isArray(
    validationCheckForPlaidBankIncome?.banks
  )
    ? validationCheckForPlaidBankIncome.banks.flatMap((bank: any) =>
        Array.isArray(bank?.bank_income_accounts)
          ? bank.bank_income_accounts.flatMap((account: any) =>
              Array.isArray(account?.bank_income_sources)
                ? account.bank_income_sources
                : []
            )
          : []
      )
    : [];
  const bankRiskState = deriveBankRiskState({
    bankSources: bankData?.banking_details?.banking,
    bankSocrStatus: bankData?.banking_details?.SOCRstatus,
    bankValidationOtherCheck: validationCheck?.other_check,
  });
  const documentIdentifiers = useMemo(() => {
    const identifiers = new Set<string>();
    collectDocumentIdentifiers(proofOfIdsData, identifiers);
    collectDocumentIdentifiers(ssnIdentificationData, identifiers);
    collectDocumentIdentifiers(IncomeAPIResponse?.data, identifiers);
    collectDocumentIdentifiers(otherIncomeData?.other_income_details, identifiers);
    collectDocumentIdentifiers(bankData?.banking_details, identifiers);
    collectDocumentIdentifiers(otherDocumentsData, identifiers);
    return identifiers;
  }, [
    proofOfIdsData,
    ssnIdentificationData,
    IncomeAPIResponse?.data,
    otherIncomeData?.other_income_details,
    bankData?.banking_details,
    otherDocumentsData,
  ]);
  const hasExistingDocuments = documentIdentifiers.size > 0;
  const isDocumentIdentifierSnapshotLoading =
    Boolean(IncomeAPIResponse?.isLoading) ||
    proofOfIdsDataLoading ||
    ssnIdentificationDataLoading ||
    otherIncomeDocLoding ||
    bankDocLoading ||
    otherDocumentsLoading;
  const hasPendingNewDocuments =
    hasPendingDocumentUpload(trn_id) ||
    hasDocumentIdentifiersChanged(trn_id, documentIdentifiers);

  useEffect(() => {
    if (!trn_id || isDocumentIdentifierSnapshotLoading) {
      return;
    }
    syncInitialDocumentIdentifiers(trn_id, documentIdentifiers);
  }, [trn_id, isDocumentIdentifierSnapshotLoading, documentIdentifiers]);

  const hasBankDocumentContext = bankRiskState.hasBankDocumentContext;
  const bankSourceSocrStatuses = bankRiskState.bankSourceStatuses;
  const isBankSectionUnverifiable = bankRiskState.isBankSectionUnverifiable;
  const normalizedFirstName = String(
    getFirstDefinedValue(
      applicantDetails?.first_name,
      proofOfIdsData?.identification_data?.first_name,
      record?.FirstName
    ) || ""
  ).trim();
  const normalizedLastName = String(
    getFirstDefinedValue(
      applicantDetails?.last_name,
      proofOfIdsData?.identification_data?.last_name,
      record?.LastName
    ) || ""
  ).trim();
  const normalizedEmail = normalizeEmail(
    getFirstDefinedValue(
      applicantDetails?.email,
      proofOfIdsData?.applicant?.email,
      record?.Email
    )
  );
  const normalizedPhone = normalizeRiskPhone(
    getFirstDefinedValue(
      applicantDetails?.mobile,
      applicantDetails?.mobile
        ? `${applicantDetails?.country_code || ""}${applicantDetails?.mobile}`
        : "",
      proofOfIdsData?.applicant?.mobile,
      record?.Mobile
    )
  );
  const normalizedSsn = normalizeDigits(
    getFirstDefinedValue(
      ssnIdentificationData?.data?.ssn_data?.SSNNumber,
      ssnIdentificationData?.data?.ssn_data?.SSN,
      proofOfIdsData?.ssn_data?.SSNNumber,
      proofOfIdsData?.ssn_data?.SSN
    )
  );
  const normalizedIdDocumentNumber = deriveRiskIdDocumentNumber(
    proofOfIdsData?.identification_data
  );
  const isIdSectionReportableForFraud = shouldReportIdFraudSection({
    isIdSectionUnverifiable,
    normalizedIdDocumentNumber,
    identificationData: idSectionData,
  });
  const reportSectionTypes = buildReportSectionTypes({
    isIdSectionUnverifiable: isIdSectionReportableForFraud,
    isSsnSectionUnverifiable,
    isEmployerSectionUnverifiable,
    isBankSectionUnverifiable,
  });
  const isRiskSourceDataReady = Boolean(
    trn_id != null &&
    !loading &&
    !proofOfIdsDataLoading &&
    !ssnIdentificationDataLoading
  );
  const reportApplicationId = record?.AppID || applicantDetails?.application_id;
  const reportApplicantId = record?.id;
  const riskMatchApplicant = useMemo(
    () => ({
      applicantId: reportApplicantId ? String(reportApplicantId) : undefined,
      firstName: normalizedFirstName,
      lastName: normalizedLastName,
      email: normalizedEmail || undefined,
      phone: normalizedPhone || undefined,
      ssn: normalizedSsn || undefined,
      idDocumentNumber: normalizedIdDocumentNumber || undefined,
    }),
    [
      reportApplicantId,
      normalizedFirstName,
      normalizedLastName,
      normalizedEmail,
      normalizedPhone,
      normalizedSsn,
      normalizedIdDocumentNumber,
    ]
  );

  const riskApplicantPayload = useMemo(() => {
    return buildRiskApplicantPayload({
      firstName: normalizedFirstName,
      lastName: normalizedLastName,
      email: normalizedEmail,
      phone: normalizedPhone,
      ssn: normalizedSsn,
      normalizedIdDocumentNumber,
      identificationData: idSectionData,
      includeNameOnly: true,
    });
  }, [
    normalizedFirstName,
    normalizedLastName,
    normalizedEmail,
    normalizedPhone,
    normalizedSsn,
    normalizedIdDocumentNumber,
    idSectionData,
  ]);

  const hasRiskLookupContext = Boolean(reportApplicationId && reportApplicantId);
  const hasRiskNonNameIdentifier = Object.keys(riskApplicantPayload).some(
    (fieldName) => fieldName !== "firstName" && fieldName !== "lastName"
  );
  const hasRiskLookupPayload =
    hasRiskNonNameIdentifier ||
    (hasRiskLookupContext &&
      Boolean(riskApplicantPayload.firstName) &&
      Boolean(riskApplicantPayload.lastName));
  const riskFallbackKey = useMemo(() => {
    const seed = [
      normalizedFirstName,
      normalizedLastName,
      normalizedEmail,
      normalizedPhone,
      normalizedSsn,
      normalizedIdDocumentNumber,
      reportApplicationId ? String(reportApplicationId) : "",
      reportApplicantId ? String(reportApplicantId) : "",
    ].join("|");
    return `risk-${hashIdentifierSeed(seed)}`;
  }, [
    normalizedFirstName,
    normalizedLastName,
    normalizedEmail,
    normalizedPhone,
    normalizedSsn,
    normalizedIdDocumentNumber,
    reportApplicationId,
    reportApplicantId,
  ]);
  const riskCacheKey = record?.id || record?.AppID || riskFallbackKey;
  const riskSourceSubscriberId =
    proofOfIdsData?.applicant?.SubscriberID ||
    data?.SubscriberID ||
    record?.SubscriberID ||
    id;
  const reportApplicationType = mapRiskReportApplicationType(
    applicantData?.Application_details?.application_type,
    appType
  );
  const [stableRiskFlag, setStableRiskFlag] = useState<boolean | null>(null);
  const reviewDoneFraudReporterRef = useRef(() => { });

  reviewDoneFraudReporterRef.current = () => {
    triggerReportFraudApplicant("15");
  };

  useEffect(() => {
    setStableRiskFlag(null);
  }, [riskCacheKey]);

  useEffect(() => {
    if (!reviewDoneFraudReporting?.registerReviewDoneFraudReporter) {
      return;
    }

    return reviewDoneFraudReporting.registerReviewDoneFraudReporter(record, () => {
      reviewDoneFraudReporterRef.current();
    });
  }, [reviewDoneFraudReporting, record]);

  const { data: riskIndicatorData, refetch: refetchRiskIndicator } = useGetOne(
    "riskIndicatorIsFraudRisk",
    {
      id: riskCacheKey,
      meta: {
        applicant: riskApplicantPayload,
        context: {
          applicationId: reportApplicationId ? String(reportApplicationId) : undefined,
          applicantId: reportApplicantId ? String(reportApplicantId) : undefined,
          subscriberId: riskSourceSubscriberId
            ? String(riskSourceSubscriberId)
            : undefined,
        },
      },
    },
    {
      enabled: Boolean(
        isActiveTab &&
        isRiskSourceDataReady &&
        hasRiskLookupPayload &&
        (userRole === typesofUsers.docuverusSuperAdmin ||
          userRole === typesofUsers.docuverusAdmin ||
          userRole === typesofUsers.superAdmin)
      ),
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000,
      retry: 1,
    }
  );
  useEffect(() => {
    if (typeof riskIndicatorData?.riskFlag === "boolean") {
      setStableRiskFlag(riskIndicatorData.riskFlag);
    }
  }, [riskIndicatorData?.riskFlag]);

  const effectiveRiskFlag =
    typeof riskIndicatorData?.riskFlag === "boolean"
      ? riskIndicatorData.riskFlag
      : stableRiskFlag;
  const shouldShowRiskFlag =
    isRiskSourceDataReady &&
    effectiveRiskFlag === true &&
    userRole === "Docuverus Super Admin" &&
    roletype !== "docupload_applicant";
  const sendMessageRecipients = React.useMemo(() => {
    const baseRecord = record || applicantData?.Application_details || {};
    const mappedRecord = {
      id: baseRecord?.id || applicant_id,
      AppID: baseRecord?.AppID || baseRecord?.application_id,
      ApplicantStatus:
        baseRecord?.ApplicantStatus || baseRecord?.application_status,
      Email: baseRecord?.Email || baseRecord?.email,
      MobileNumber: baseRecord?.MobileNumber || baseRecord?.mobile,
      FirstName: baseRecord?.FirstName || baseRecord?.first_name,
      LastName: baseRecord?.LastName || baseRecord?.last_name,
    };

    const hasContactInfo = mappedRecord?.Email || mappedRecord?.MobileNumber;
    return mappedRecord.id && hasContactInfo ? [mappedRecord] : [];
  }, [applicantData, applicant_id, record]);
  const resendInviteRecord = sendMessageRecipients.length > 0 ? sendMessageRecipients[0] : record;
  const resendInviteApplicationNumber =
    applicationId ||
    applicantDetails?.application_id ||
    resendInviteRecord?.ApplicationNumber ||
    resendInviteRecord?.AppID;
  const resendInviteSubscriberId =
    proofOfIdsData?.applicant?.SubscriberID ||
    data?.SubscriberID ||
    id;
  const canShowResendInvite = React.useMemo(() => {
    const isInviteApp =
      appType == "1" ||
      applicantData?.Application_details?.application_type === "Application Invite";
    const isDocUpload =
      appType == "2" ||
      applicantData?.Application_details?.application_type === "Doc Upload";
    const isGuestCard =
      appType == "3" ||
      applicantData?.Application_details?.application_type === "Guest Card";
    return (
      (isInviteApp && resendInviteRecord?.ApplicantStatus === "Invited") ||
      isDocUpload ||
      isGuestCard
    );
  }, [appType, applicantData, resendInviteRecord]);
  const applicantValidationMessages = React.useMemo(() => {
    const profileSections = sectionPermission?.data?.status;
    return buildSendMessageValidationSectionsFromResponses(profileSections, {
      idValidation: validationCheckForID,
      employerValidation: validationCheckForIncome,
      bankValidation: validationCheck,
      argylePayrollValidation: validationCheckForArgylePayrollIncome,
      argyleBankValidation: validationCheckForArgyleBankIncome,
      plaidBankValidation: validationCheckForPlaidBankIncome,
      plaidPayrollValidation: validationCheckForPlaidPayrollIncome,
    });
  }, [
    sectionPermission?.data?.status,
    validationCheckForID,
    validationCheck,
    validationCheckForIncome,
    validationCheckForArgyleBankIncome,
    validationCheckForArgylePayrollIncome,
    validationCheckForPlaidBankIncome,
    validationCheckForPlaidPayrollIncome,
  ]);
  const applicantValidationPrefill = buildSectionedPrefill(applicantValidationMessages, { includeBullets: true });
  // 
  function getLowestStatus() {

    let employeeStatus: (number | null)[] = [];
    let bankStatus: (number | null)[] = [];


    const idStatus = proofOfIdsData?.identification_data?.ManualSOCRstatus
      ? proofOfIdsData?.identification_data?.ManualSOCRstatus
      : validationCheckForID?.SOCRStatus;
    const ssnStatus = ssnIdentificationData?.data?.ssn_data?.manualsocr
      ? ssnIdentificationData?.data?.ssn_data?.manualsocr
      : ssnIdentificationData?.data?.ssn_data?.calculatedscocr;

    if (IncomeAPIResponse?.data?.employment_details?.SOCRstatus || validationCheckForIncome?.other_check) {
      const employeeStatusFromIncome = IncomeAPIResponse?.data?.employment_details?.SOCRstatus
        ? Object.values(IncomeAPIResponse?.data?.employment_details?.SOCRstatus).filter((status) => status !== null && status !== undefined)
        : [];

      const employeeStatusFromValidation = validationCheckForIncome?.other_check
        ? Object.values(validationCheckForIncome?.other_check)
          .map((source) => (source as any)?.SOCRStatus)
          .filter((status) => status !== null && status !== undefined)
        : [];

      employeeStatus = employeeStatusFromIncome.length ? employeeStatusFromIncome : employeeStatusFromValidation;
    }

    if (bankData?.banking_details?.SOCRstatus || validationCheck?.other_check) {
      bankStatus = bankSourceSocrStatuses;
    }


    const statusMapping = {
      "1": "Verified",
      "2": "Unverified",
      "3": "Further Documentation Required"
    };

    const ssnValue = Number(ssnStatus);
    const ssnIncluded =
      ssnValue === 1 || ssnValue === 2 ? ssnValue : null;
    const statuses = [idStatus, ssnIncluded, ...employeeStatus, ...bankStatus]
      .filter(status => status !== null && status !== undefined)
      .map(status => statusMapping[status]);



    const lowestStatus = statuses.includes("Unverified")
      ? "Unverified"
      : statuses.includes("Further Documentation Required")
        ? "Further Documentation Required"
        : statuses.includes("Verified")
          ? "Verified"
          : null;

    return lowestStatus;
  }

  const applicantStatusKey = (appStatus == 13 || appStatus == 14 || appStatus == 15) ? appStatus : getLowestStatus()

  useEffect(() => {
    let statusValue: any = null;
    if (applicantStatusKey !== null) {


      statusValue = (applicantStatusKey == "Further Documentation Required" || applicantStatusKey == 14) ? 14 : (applicantStatusKey == "Unverified" || applicantStatusKey == 15) ? 15 : 13;
    }
    methods.setValue("application_status", statusValue);
  }, [applicantStatusKey]);

  const { data: getlookbacks } = useGetOne(
    "getlookbacks",
    { id: reportApplicationId },
    { enabled: reportApplicationId != null, refetchOnWindowFocus: true }
  );
  const payrollLookbackWeeks = Number(getlookbacks?.data?.paystub_lookback) || null;
  const subscriberIdForProfile = resolveSubscriberIdForStaffProfile({
    isApplicantViewer: isApplicantClassViewer({
      userrole: userRole,
      roletype,
    }),
    recordSubscriberId: record?.SubscriberID,
    proofSubscriberId: proofOfIdsData?.applicant?.SubscriberID,
    applicantSubscriberId:
      applicantData?.subscriber_details?.SubscriberID ||
      applicantData?.data?.subscriber_details?.SubscriberID,
    officeId: office_id,
    routeId: id,
  });
  const { data: subscriberProperties } = useGetList(
    "Property",
    {
      pagination: { page: 1, perPage: 1000 },
      sort: { field: "id", order: "ASC" },
      filter: { subscriberID: subscriberIdForProfile },
    },
    {
      enabled: subscriberIdForProfile != null,
      refetchOnWindowFocus: false,
    }
  );
  const { data: subscriberApplicationProfiles } = useGetOne(
    "application-profile",
    { id: subscriberIdForProfile },
    {
      enabled: subscriberIdForProfile != null,
      refetchOnWindowFocus: false,
    }
  );
  const propertyNameForProfile =
    applicantDetails?.office_property_name ||
    applicantData?.Application_details?.office_property_name ||
    record?.Property;
  const propertyIdForProfile =
    applicantDetails?.PropertyID ||
    applicantDetails?.property_id ||
    applicantData?.Application_details?.PropertyID ||
    applicantData?.Application_details?.property_id ||
    record?.PropertyID;
  const applicationProfileId = resolveApplicationProfileId(
    applicantData?.Application_details,
    applicantDetails,
    applicantData?.data?.subscriber_details,
    proofOfIdsData?.applicant,
    record,
    getlookbacks?.data,
    getlookbacks?.data?.data
  ) ??
    resolveApplicationProfileIdFromProperties(
      subscriberProperties,
      propertyNameForProfile,
      propertyIdForProfile
    ) ??
    resolveSoleApplicationProfileId(
      subscriberApplicationProfiles?.data ?? subscriberApplicationProfiles
    );
  const { data: applicationProfileDetails } = useGetOne(
    "getapplicationprofiledetails",
    { id: [applicationProfileId] },
    { enabled: applicationProfileId != null, refetchOnWindowFocus: true }
  );
  const applicationProfileLinking =
    selectApplicationProfileRecord(
      applicationProfileDetails,
      applicationProfileId
    ) ??
    (applicationProfileDetails?.profiledetails
      ? null
      : applicationProfileDetails);
  const linkingValueFromLookbacks = (field: string) =>
    getlookbacks?.data?.[field] ?? getlookbacks?.data?.data?.[field];
  // The application row's linking flags decide the linking widgets.
  // Document sections keep the profile section's own visibility and required state.
  const bankIncomeDepositLinkingValue =
    linkingValueFromLookbacks(BANK_INCOME_DEPOSIT_LINKING_FIELD) ??
    applicationProfileLinking?.[BANK_INCOME_DEPOSIT_LINKING_FIELD];
  const payrollLinkingValue =
    linkingValueFromLookbacks(PAYROLL_LINKING_FIELD) ??
    applicationProfileLinking?.[PAYROLL_LINKING_FIELD];
  const bankIncomeDepositLinkingEnabled = isLinkingSettingEnabled(
    bankIncomeDepositLinkingValue
  );
  const payrollLinkingEnabled = isLinkingSettingEnabled(payrollLinkingValue);
  const payrollLinkingUiEnabled =
    payrollLinkingEnabled && anyPayrollProviderEnabled;
  const bankIncomeDepositLinkingMode = toLinkingSectionMode(
    bankIncomeDepositLinkingValue
  );
  const payrollLinkingMode = toLinkingSectionMode(payrollLinkingValue);
  const employmentDocumentSection = applyDocumentSectionVisibility(
    sectionPermission?.data?.status?.[0]?.state,
    payrollLinkingMode
  );
  const bankingDocumentSection = applyDocumentSectionVisibility(
    sectionPermission?.data?.status?.[1]?.state,
    bankIncomeDepositLinkingMode
  );

  useEffect(() => {
    if (zipDownload) {
      setTimeout(() => {
        notify("Downloading documents...", {
          type: "success",
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
      });
    }
  }, [zipDownload]);

  const [isDownloading, setIsDownloading] = useState(false);
  const downloadZip = async (id: string) => {
    setIsDownloading(true);
    try {

      setZipDownload(true);
      const res = await dataProvidersAts.downloadZip(id);
      if (res) {
        toast.success("downloading documents......", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
      setZipDownload(false);

    }
    finally {
      setIsDownloading(false);
    }
  };
  const { permissions } = usePermissions();

  const [create] = useCreate();
  const refresh = useRefresh();

  const getVrApplicantRouteTelemetryContext = () => {
    const pathname =
      typeof window !== "undefined" ? window.location.pathname : "";
    const segments = pathname
      .split("/")
      .map((segment) => segment.trim())
      .filter(Boolean);

    if (!segments.length) {
      return {
        routeType: null,
        isGuestCard: false,
      };
    }

    const docuploadRoleIndex = segments.findIndex(
      (segment) => segment.toLowerCase() === "docupload_applicant"
    );

    if (docuploadRoleIndex === -1) {
      return {
        routeType: null,
        isGuestCard: false,
      };
    }

    const flowSegments = segments.slice(docuploadRoleIndex + 1);
    const routeMarker = flowSegments[0]?.toLowerCase();
    const isGuestCard = routeMarker === "guestcard";
    const routeScope = (isGuestCard ? flowSegments[1] : flowSegments[0])?.toLowerCase();

    const routeTypeMap: Record<string, string> = {
      office: "docupload_office",
      property: "docupload_property",
      floor: "docupload_floor",
      unit: "docupload_unit",
    };

    return {
      routeType: routeScope ? routeTypeMap[routeScope] || "docupload_unknown" : null,
      isGuestCard,
    };
  };

  const isVrApplicantSubmitTelemetryEligible =
    roletype === "docupload_applicant" &&
    applicantData?.Application_details?.application_type === "Doc Upload";

  const getVrApplicantSubmitErrorCategory = (error: any) => {
    const errorStatus =
      error?.status ??
      error?.statusCode ??
      error?.response?.status ??
      null;

    if (typeof errorStatus === "number") {
      if (errorStatus >= 400 && errorStatus < 500) {
        return "validation_failed";
      }

      return "request_failed";
    }

    return "unknown_error";
  };

  const buildVrApplicantSubmitTelemetryPayload = ({
    finalStatus,
    responseData,
  }: {
    finalStatus: string | number | null;
    responseData?: any;
  }) => {
    const responsePayload = responseData?.data || responseData || {};
    const { routeType, isGuestCard } = getVrApplicantRouteTelemetryContext();

    return {
      applicationNumber: telemetryApplicationNumber || null,
      applicantId: telemetryApplicantId || null,
      trnId: trn_id || null,
      subscriberId:
        record?.SubscriberID ||
        data?.SubscriberID ||
        responsePayload?.SubscriberID ||
        null,
      previousApplicationStatus:
        applicantData?.Application_details?.application_status ?? null,
      requestedStatus: finalStatus ?? null,
      resolvedFinalStatus: finalStatus ?? null,
      hasExistingDocuments,
      hasPendingNewDocuments,
      forceApplicantSubmitted: true,
      routeType,
      isGuestCard,
      timestamp: new Date().toISOString(),
      ...(responseData
        ? {
          responseSuccess: responsePayload?.success ?? true,
          returnedRecords: responsePayload?.records ?? null,
          returnedStatus:
            responsePayload?.status ??
            responsePayload?.applicationStatus ??
            null,
        }
        : {}),
    };
  };

  const buildVrApplicantSubmitErrorTelemetryPayload = ({
    finalStatus,
    error,
  }: {
    finalStatus: string | number | null;
    error: any;
  }) => ({
    ...buildVrApplicantSubmitTelemetryPayload({ finalStatus }),
    responseSuccess: false,
    errorStatus:
      error?.status ??
      error?.statusCode ??
      error?.response?.status ??
      null,
    errorCategory: getVrApplicantSubmitErrorCategory(error),
  });

  const trackVrApplicantSubmitEvent = (
    eventName: string,
    payload: Record<string, unknown>
  ) => {
    if (!isVrApplicantSubmitTelemetryEligible) {
      return;
    }

    try {
      openpanel.track(eventName, payload);
    } catch {
      // Telemetry must not block applicant submit status updates.
    }
  };

  const emitVrSubmitTelemetry = () => {
    if (!telemetryApplicationNumber) {
      return;
    }
    if (
      userRole !== typesofUsers.docuverusSuperAdmin &&
      userRole !== typesofUsers.docuverusAdmin &&
      userRole !== typesofUsers.superAdmin
    ) {
      return;
    }

    const session = getVrReviewSession(telemetryApplicationNumber);
    create(
      "telemetryEvent",
      {
        data: {
          eventType: "vr_submit",
          applicationNumber: telemetryApplicationNumber,
          applicantId: telemetryApplicantId || null,
          subscriberId: record?.SubscriberID || data?.SubscriberID || null,
          trn_id: trn_id || null,
          session,
          source: "dashboard",
        },
      },
      { onError: () => { } }
    );
  };

  const clearNewTagsImmediately = async () => {
    const applicationNumber =
      record?.AppID || applicantDetails?.application_id || data?.AppID;
    const applicantIdForTag =
      record?.id || applicant_id || applicantData?.Application_details?.id;
    try {
      await updateNewTagsForApplicantsUnconditional({
        create,
        applicationNumber,
        applicantData: applicantIdForTag ? [{ id: applicantIdForTag }] : [],
      });
      if (applicationNumber && !applicantIdForTag) {
        create("updatenewtagapp", { data: { ApplicationNumber: applicationNumber } });
      }
      setApplicantInfo((prev) =>
        applyReviewDoneTimestamp(prev, userRole, new Date().toISOString())
      );
      refresh();
    } catch (_error) {
      // Prevent secondary failures from blocking status/review success flow.
    }
  };
  const onClickScreeningReport = async (event, data, record) => {
    create(
      "getscreeningreport",
      {
        data: {
          applicantID: record?.id,
          subscriberId: data?.SubscriberID,
        },
      },
      {
        onSuccess: () => {
          notify(`Screening report opened successfully.`, {
            type: "success",
            anchorOrigin: { vertical: "top", horizontal: "right" },
          });
        },
        onError: (e: any) =>
          notify(`Operation fail:${e.message}`, {
            type: "error",
            anchorOrigin: { vertical: "top", horizontal: "right" },
          }),
      }
    );
  };
  const formSubmitApiCall = async (id) => {
    const shouldForceReviewPendingOnReopenedDocUploadSubmit =
      isDocUploadApp &&
      String(applicantData?.Application_details?.application_status ?? "") ===
      "2" &&
      hasExistingDocuments;

    const finalStatus = resolveSubmitStatus({
      currentStatus: applicantData?.Application_details?.application_status,
      hasExistingDocuments,
      hasPendingNewDocuments,
      normalizeInvitedSubmitToInProgress: isDocUploadApp,
      forceReviewPendingWhenExistingDocuments:
        shouldForceReviewPendingOnReopenedDocUploadSubmit,
    });
    const final_paylaod = {
      trn_id: id,
      role: "applicant",
      status: finalStatus,
      forceApplicantSubmitted: true,
      subUrl: "/document/updateApplicationStatus",
      office_property_name: record?.Property,
    };
    try {
      trackVrApplicantSubmitEvent(
        "vr_applicant_submit_clicked",
        buildVrApplicantSubmitTelemetryPayload({ finalStatus })
      );
      const updateResponse = await dataProvider.update("other_sections", {
        id: id,
        data: final_paylaod,
        previousData: proofOfIdsData,
      });
      trackVrApplicantSubmitEvent(
        "vr_applicant_submit_api_success",
        buildVrApplicantSubmitTelemetryPayload({
          finalStatus,
          responseData: updateResponse,
        })
      );
      resetDocumentUploadTracking(id, documentIdentifiers);
      flushSync(() => {
        disableLeaveGuardForPage();
      });
      navigation("/admin/success", { replace: true });
      trackVrApplicantSubmitEvent(
        "vr_applicant_submit_navigation_success",
        buildVrApplicantSubmitTelemetryPayload({
          finalStatus,
          responseData: updateResponse,
        })
      );
      notify(`Application submitted Successfully`, {
        type: "success",
        anchorOrigin: { vertical: "top", horizontal: "right" },
      });
    } catch (e) {
      trackVrApplicantSubmitEvent(
        "vr_applicant_submit_api_error",
        buildVrApplicantSubmitErrorTelemetryPayload({
          finalStatus,
          error: e,
        })
      );
      notify(`Error: fail submitting application details`, {
        type: "warning",
        anchorOrigin: { vertical: "top", horizontal: "right" },
      });
    }
  }
  const navigateToPrevTab = () => {
    const currentTab = document.querySelector('#nav-tab .nav-link.active') as HTMLElement | null;
    const currentTabBody = document.querySelector('#nav-tabContent .active') as HTMLElement | null;
    const isPrevTabPresent = currentTab?.previousElementSibling as HTMLElement | null;
    if (currentTab && currentTabBody && isPrevTabPresent) {
      currentTab.classList.remove('active');
      currentTabBody.classList.remove('active');
      currentTabBody.classList.remove('show');

      const prevTab = currentTab.previousElementSibling as HTMLElement | null;
      const prevTabBody = currentTabBody.previousElementSibling as HTMLElement | null;
      if (prevTab && prevTabBody) {
        prevTab?.classList.add('active');
        prevTabBody?.classList.add('active');
        prevTabBody?.classList.add('show');
        prevTab.scrollIntoView()
      }
    }
  }
  const handleApplicantSubmitNext = (id) => {
    if (totalApplicationCount > 1) {
      const currentTab = document.querySelector('#nav-tab .nav-link.active') as HTMLElement | null;
      const currentTabBody = document.querySelector('#nav-tabContent .active') as HTMLElement | null;

      const isNextTabPresent = currentTab?.nextElementSibling as HTMLElement | null;

      if (currentTab && currentTabBody && isNextTabPresent) {
        currentTab.classList.remove('active');
        currentTabBody.classList.remove('active');
        currentTabBody.classList.remove('show');

        const nextTab = currentTab.nextElementSibling as HTMLElement | null;
        const nextTabBody = currentTabBody.nextElementSibling as HTMLElement | null;
        if (nextTab && nextTabBody) {
          nextTab?.classList.add('active');
          nextTabBody?.classList.add('active');
          nextTabBody?.classList.add('show');
          nextTab.scrollIntoView()
          if (!shouldHandleApplicantStatusOnSubmitOnly) {
            handle_Admin_Submit_Next(methods.getValues());
          }
        }

      } else {
        const allButLastAreTrue = tabValidation.every(value => value === true);
        if (allButLastAreTrue) {
          formSubmitApiCall(id);
        }

        else {
          const nextTab = document.querySelector(`#nav-tab .nav-link:nth-child(${tabValidation.indexOf(false) + 1})`) as HTMLElement | null;
          const currentTabBody = document.querySelector(`#nav-tabContent .active `) as HTMLElement | null;
          const nextTabBody = document.querySelector(`#nav-tabContent .tab-pane:nth-child(${tabValidation.indexOf(false) + 1})`) as HTMLElement | null;
          if (nextTab && nextTabBody) {
            nextTab?.classList.add('active');
            currentTab?.classList.remove('active');
            currentTabBody?.classList.remove('active');
            currentTabBody?.classList.remove('show');
            nextTabBody?.classList.add('active');
            nextTabBody?.classList.add('show');
            nextTab.scrollIntoView()
            if (!shouldHandleApplicantStatusOnSubmitOnly) {
              handle_Admin_Submit_Next(methods.getValues());
            }
          }
        }
      }
    } else {
      {
        if (tabValidation.includes(false))
          formSubmitApiCall(id)
        else {
          const nextTab = document.querySelector(`#nav-tab .nav-link:nth-child(${tabValidation.indexOf(false) + 1})`) as HTMLElement | null;
          const nextTabBody = document.querySelector(`.tab-pane:nth-child(${tabValidation.indexOf(false) + 1})`) as HTMLElement | null;
          if (nextTab && nextTabBody) {
            nextTab?.classList.add('active');
            nextTabBody?.classList.add('active');
            nextTab.scrollIntoView()
          }
        }
      }
    }
  };
  const handleApplicantSubmit = (id) => {
    formSubmitApiCall(id);
  };
  const [updateApplicant, updateApplicantStatus] = useCreate();
  const [reportFraudApplicant] = useCreate();

  const buildReportFraudApplicantPayload = (sectionTypes: string[]) => {
    const missingFields: string[] = [];
    if (!reportApplicationType) missingFields.push("applicationType");
    if (!reportApplicationId) missingFields.push("applicationId");
    if (!reportApplicantId) missingFields.push("applicantId");

    if (missingFields.length > 0) {
      console.warn("reportFraudApplicant skipped: missing required fields", {
        missingFields,
        appStatus,
      });
      return null;
    }

    const reportFraudIdentifierPayload = buildRiskApplicantPayload({
      email: normalizedEmail,
      phone: normalizedPhone,
      ssn: normalizedSsn,
      normalizedIdDocumentNumber,
      identificationData: idSectionData,
    });
    const hasReportFraudApplicantName = Boolean(normalizedFirstName && normalizedLastName);
    const hasAdditionalApplicantIdentifier =
      Object.keys(reportFraudIdentifierPayload).length > 0;

    if (!hasAdditionalApplicantIdentifier && !hasReportFraudApplicantName) {
      console.warn("reportFraudApplicant skipped: no applicant identifier", {
        appStatus,
      });
      return null;
    }

    const applicant: any = {};

    if (normalizedFirstName) {
      applicant.firstName = normalizedFirstName;
    }
    if (normalizedLastName) {
      applicant.lastName = normalizedLastName;
    }

    Object.assign(applicant, reportFraudIdentifierPayload);

    return {
      applicant,
      context: {
        applicationType: reportApplicationType,
        applicationId: String(reportApplicationId),
        applicantId: String(reportApplicantId),
        sectionTypes,
      },
    };
  };

  const triggerReportFraudApplicant = (nextStatus: any) => {
    const normalizedNextStatus = String(nextStatus ?? "").trim();
    console.info("reportFraudApplicant evaluation", {
      normalizedNextStatus,
      reportSectionTypes,
      hasIdSectionDocumentContext,
      idSectionSocrStatus,
      isIdSectionUnverifiable,
      hasSsnSectionDocumentContext,
      ssnSectionSocrStatus,
      isSsnSectionUnverifiable,
      hasEmployerDocumentContext,
      employerSourceSocrStatuses,
      isEmployerSectionUnverifiable,
      hasBankDocumentContext,
      bankSourceSocrStatuses,
      isBankSectionUnverifiable,
    });

    if (
      !(
        userRole === typesofUsers.docuverusSuperAdmin ||
        userRole === typesofUsers.docuverusAdmin ||
        userRole === typesofUsers.superAdmin
      )
    ) {
      console.info("reportFraudApplicant skipped: role not permitted", {
        userRole,
      });
      return;
    }

    const payload = buildReportFraudApplicantPayload(reportSectionTypes);
    if (!payload) {
      console.info("reportFraudApplicant skipped: payload not ready", {
        sectionTypes: reportSectionTypes,
      });
      return;
    }

    reportFraudApplicant(
      "reportFraudApplicant",
      { data: payload },
      {
        onSuccess: () => {
          console.info("reportFraudApplicant success", { sectionTypes: reportSectionTypes });
          setStableRiskFlag(true);
          refetchRiskIndicator();
          refetch();
        },
        onError: (error: any) => {
          console.error(
            "reportFraudApplicant failed",
            reportSectionTypes,
            error?.message || error
          );
        },
      }
    );
  };

  const handle_Admin_Submit = async (values) => {
    const shouldForceReviewPending = userRole !== "Docuverus Super Admin";
    const finalStatus = resolveSubmitStatus({
      requestedStatus: values?.application_status,
      currentStatus: applicantData?.Application_details?.application_status,
      hasExistingDocuments,
      hasPendingNewDocuments,
      forceReviewPending: shouldForceReviewPending,
    });

    const final_paylaod = {
      trn_id: trn_id,
      role: userRole,
      status: finalStatus,
      office_property_name: record?.Property,
      grossMonthlyPay: grossMonthlyPay,
      // ADO 4853: identifies this specific Submit click/attempt so the backend
      // can dedupe a retried/double-clicked request without treating a
      // genuine later resubmission as a duplicate (see getSubmitIdempotencyKey
      // above).
      idempotencyKey: getSubmitIdempotencyKey(trn_id, finalStatus),
    };



    updateApplicant(
      "updateApplicationStatus",
      {
        data: final_paylaod,
      },
      {
        onSuccess: (data) => {
          // ADO 4853: this attempt is settled — clear the cached key so a
          // later, genuinely new submission for this VR (which may resolve
          // to the same disposition, e.g. Review Pending) gets its own key
          // instead of being deduped as a retry of this one.
          clearSubmitIdempotencyKey();
          if (appType === "2") {
            emitVrSubmitTelemetry();
            const storedOpenedAt = Number(
              sessionStorage.getItem(`review_${telemetryApplicationNumber}_opened`)
            );
            const openedAt = !isNaN(storedOpenedAt) && storedOpenedAt > 0
              ? storedOpenedAt
              : reviewOpenedAtRef.current;
            const now = Date.now();
            const durationMs = openedAt ? now - openedAt : null;
            openpanel.track("vr_application_review_done", {
              applicationNumber: telemetryApplicationNumber,
              applicantId: telemetryApplicantId || null,
              applicationType: "VR",
              subscriberId: record?.SubscriberID || data?.SubscriberID || null,
              trnId: trn_id || null,
              newStatus: final_paylaod.status,
              previousStatus: applicantData?.Application_details?.application_status,
              review_duration_ms: durationMs,
              review_duration_sec: durationMs != null ? Math.floor(durationMs / 1000) : null,
              review_duration_min: durationMs != null ? +(durationMs / 60000).toFixed(2) : null
            });
          }
          resetDocumentUploadTracking(trn_id, documentIdentifiers);
          notify(data?.records, {
            type: "success",
            anchorOrigin: { vertical: "top", horizontal: "right" },
          });
          if (
            reportApplicationType === "VR" &&
            reviewDoneFraudReporting?.reportFraudForApplicants
          ) {
            reviewDoneFraudReporting.reportFraudForApplicants();
          } else {
            triggerReportFraudApplicant(final_paylaod.status);
          }
          refetch();
          clearNewTagsImmediately();

          if (
            values?.application_status == "13" ||
            values?.application_status == "14" ||
            values?.application_status == "15"
          ) {

            if (isThirdPartyIntegration) {

              handledsendLeaseDocument();
            }
          }
        },
        onError: (error: any) => {
          // ADO 4853: the backend returns a 4xx (not 2xx) when the immutable
          // snapshot fails to capture, so this — not onSuccess — is the path
          // that actually runs. The status change was never committed either
          // (see controller_docupload.js updateApplicationStatus), so the VR
          // was never actually submitted; the idempotency key above is left
          // in place for retryable failures. A non-retryable key conflict is
          // cleared so the next click can submit with a fresh key.
          const snapshot = error?.body?.snapshot;
          if (snapshot?.success === false) {
            if (snapshot.retryable === false) {
              clearSubmitIdempotencyKey();
            }
            notify(
              snapshot.error ||
                "Submission failed while generating the report record. Please click Submit again.",
              {
                type: "warning",
                anchorOrigin: { vertical: "top", horizontal: "right" },
              }
            );
            return;
          }
          notify(`${error.message}`, {
            type: "warning",
            anchorOrigin: { vertical: "top", horizontal: "right" },
          });
        },
      }
    );
  };

  const handle_Admin_Submit_Next = async (values) => {
    const isApplicantRole =
      String(userRole || "").trim().toLowerCase() === typesofUsers.applicant;
    const finalStatusNext = isApplicantRole ? 2 : values.application_status ? values.application_status : "14";

    const final_paylaod = {
      trn_id: trn_id,
      role: userRole,
      status: finalStatusNext,
      ...(isApplicantRole ? { forceApplicantSubmitted: true } : {}),
      office_property_name: record?.Property,
      grossMonthlyPay: grossMonthlyPay,
      // See handle_Admin_Submit above — this call hits the same
      // updateApplicationStatus gate and can carry a terminal status too.
      idempotencyKey: getSubmitIdempotencyKey(trn_id, finalStatusNext),
    };



    updateApplicant(
      "updateApplicationStatus",
      {
        data: final_paylaod,
      },
      {
        onSuccess: (data) => {
          // See handle_Admin_Submit's onSuccess above — same reasoning applies here.
          clearSubmitIdempotencyKey();
          notify(data?.records, {
            type: "success",
            anchorOrigin: { vertical: "top", horizontal: "right" },
          });
          if (
            reportApplicationType === "VR" &&
            reviewDoneFraudReporting?.reportFraudForApplicants
          ) {
            reviewDoneFraudReporting.reportFraudForApplicants();
          } else {
            triggerReportFraudApplicant(final_paylaod.status);
          }
          refetch();
          clearNewTagsImmediately();

          if (
            values?.application_status == "13" ||
            values?.application_status == "14" ||
            values?.application_status == "15"
          ) {

            if (isThirdPartyIntegration) {

              handledsendLeaseDocument();
            }
          }

        },
        onError: (error: any) => {
          // See handle_Admin_Submit's onError above — same reasoning applies here.
          const snapshot = error?.body?.snapshot;
          if (snapshot?.success === false) {
            if (snapshot.retryable === false) {
              clearSubmitIdempotencyKey();
            }
            notify(
              snapshot.error ||
                "Submission failed while generating the report record. Please click Submit again.",
              {
                type: "warning",
                anchorOrigin: { vertical: "top", horizontal: "right" },
              }
            );
            return;
          }
          notify(`${error.message}`, {
            type: "warning",
            anchorOrigin: { vertical: "top", horizontal: "right" },
          });
        },
      }
    );
  };
  const handledsendLeaseDocument = () => {

    const authJson = localStorage.getItem("auth") || "";
    let authObj = authJson ? JSON.parse(authJson) : {};
    if (authObj.data && authObj.data.hasOwnProperty('permissions')) {
      delete authObj.data.permissions;
    }
    if (authObj.data && authObj.data.hasOwnProperty('systemNotification')) {
      delete authObj.data.systemNotification;
    }


    const updatedAuthJson = JSON.stringify(authObj);

    const formattedCreatedOn = applicantDetails?.creataed_on
      ? moment(applicantDetails?.creataed_on).format("MM/DD/YYYY h:mm A z")
      : "";
    const url = `${window.location.protocol}//${window.location.host}/admin/docupload_admin/Office/11/TestRealEstateCompany-Philadelphia/NuEF07JC8UuAluc0k-r7Yg/${trn_id +
      `?auth=` +
      encodeURIComponent(updatedAuthJson) +
      `&createdDateAsPerClientRequest=` +
      formattedCreatedOn
      }`
    updateApplicant(
      "sendLeaseDocument",
      {
        data: {
          trn_id: trn_id,
          url: url,
        },
      },
      {
        onSuccess: (data) => { },
        onError: (error: any) => { },
      }
    );
  };
  const navigate = useNavigate();
  const hasAnyStatusOne = (objects) => {
    return objects ? objects?.some((object) => object?.status === 1) : false;
  };

  useEffect(() => {
    if (getSubscriberConfigurations?.records) {
      let thirdPartyIntegration;
      if (
        typeof getSubscriberConfigurations?.records?.ThirdPartyIntegration !==
        "object"
      ) {
        thirdPartyIntegration = JSON?.parse(
          getSubscriberConfigurations?.records?.ThirdPartyIntegration
        );
      } else {
        thirdPartyIntegration =
          getSubscriberConfigurations?.records?.ThirdPartyIntegration;
      }
      setIsThirdPartyIntegration(hasAnyStatusOne(thirdPartyIntegration));
    }
  }, [getSubscriberConfigurations?.records]);

  React.useEffect(() => {
    if (id) {
      sessionStorage.setItem("trn_id", JSON.stringify(id));
    }
  }, [id]);

  const onClickDocsHandler = async (event, applicantData) => {
    console.log(record, applicantData?.id, "sfsdfsdf")
    const getalldocs = await dataProvider.getOne("getalldocs", {
      id: record?.id || applicantData?.id,
    });
    if (getUserData?.userrole == typesofUsers.landlordThirdPartyAgent) {
      return navigation("/landloard/docview", {
        state: { getalldocs: getalldocs?.data?.data, record },
      });
    }
    navigation("/ats/docview", {
      state: { getalldocs: getalldocs?.data?.data, record },
    });
  };


  const onClickViewSecondaryApp = async (event, applicantData) => {
    const getSecondaryApp = await dataProvider.getOne("getSecondaryApp", {
      id: record?.Trnid,
    });


    navigation("/ats/secondaryAppView", {
      state: { getSecondaryApp: getSecondaryApp?.data?.data, record },
    });
  };
  let proof_of_id_section: any = null;
  let proof_of_ssn_section: any = null;
  let bank_income_section: any = null;
  let plaid_payroll_income_section: any = null;
  let proof_of_income_section: any = null;
  let other_income_section: any = null;
  let bank_section: any = null;
  const submitButnRef = React.useRef<HTMLButtonElement>(null);
  const userrole: any = useGetIdentity();
  const role: any = useSelector((state: RootState) => state.users.role);
  const [clickCount, setClickCount] = useState(0);
  const [sidebarOutlineRoot, setSidebarOutlineRoot] = useState<HTMLElement | null>(null);
  const [moveDrawerOpen, setMoveDrawerOpen] = useState(false);
  const applicantOtherDocumentsRef = useRef<HTMLDivElement | null>(null);
  const outlineContentRootId = `doc-analysis-outline-${record?.Trnid || trn_id || index}`;
  const [leaveGuardDisabled, setLeaveGuardDisabled] = useState(false);
  const loggedInUserRole =
    userrole?.data?.userrole || userrole?.identity?.userrole || "";
  const isDocuverusSuperAdminUser =
    loggedInUserRole === typesofUsers.docuverusSuperAdmin;
  const isApplicantUser =
    String(role || userrole?.identity?.userrole || userrole?.data?.userrole || "")
      .trim()
      .toLowerCase() === typesofUsers.applicant;
  const shouldProtectLeave = shouldProtectApplicantLeave({
    applicationStatus: appStatus ?? record?.ApplicationStatus,
    disabled: leaveGuardDisabled,
    isApplicant: isApplicantUser,
  });
  const {
    cancelLeave,
    confirmLeave,
    isLeavePromptOpen,
    queueLeaveAction,
  } = useLeaveProtection(shouldProtectLeave);

  useEffect(() => {
    if (!isActiveTab || !isDocuverusSuperAdminUser) return undefined;

    let currentRoot: HTMLElement | null = null;

    const captureRoot = () => {
      const rootElement = document.getElementById(
        "doc-analysis-sidebar-outline-root"
      ) as HTMLElement | null;
      if (rootElement && rootElement !== currentRoot) {
        currentRoot = rootElement;
        setSidebarOutlineRoot(rootElement);
      }
      return rootElement;
    };

    captureRoot();

    // The outline root lives in the layout sidebar. That node is recreated
    // when the responsive Drawer switches between its permanent (desktop) and
    // temporary (narrow) variants, and it may commit after this route content.
    // Keep observing so we (re)capture the live node whenever it's added or
    // replaced; otherwise the portal targets a stale/detached node and the
    // sidebar renders empty. The connected check keeps the callback cheap on a
    // busy page — we only re-query once the tracked node leaves the DOM.
    const observer = new MutationObserver(() => {
      if (currentRoot && currentRoot.isConnected) return;
      captureRoot();
    });
    observer.observe(document.body, { childList: true, subtree: true });

    activeOutlineBodyClassCount += 1;
    if (activeOutlineBodyClassCount === 1) {
      document.body.classList.add("doc-analysis-outline-active");
    }

    return () => {
      observer.disconnect();
      activeOutlineBodyClassCount = Math.max(0, activeOutlineBodyClassCount - 1);
      if (activeOutlineBodyClassCount === 0) {
        document.body.classList.remove("doc-analysis-outline-active");
      }
      setSidebarOutlineRoot(null);
    };
  }, [isActiveTab, isDocuverusSuperAdminUser]);

  const disableLeaveGuardForPage = () => {
    setLeaveGuardDisabled(true);
  };

  useEffect(() => {
    setLeaveGuardDisabled(false);
  }, [trn_id]);

  const launchApplication = ({ username, applicantId, applicationNumber, subscriberId }) => {

    if ((Number(record?.ApplicationCompleted) > 79))
      return '#';
    create(
      "loginFromAdminDashboard",
      {
        data: {
          email: username,
          applicantId,
          applicationNumber,
          subscriberId,
        },
      },
      {
        onSuccess: (data) => {

          openWithPopupCheck(data?.records?.launchUrl, "_blank", undefined, {
            onBlocked: notifyPopupBlocked(notify),
          });
          setState(data?.records?.launchUrl);

        },
        onError: (e: any) =>
          notify(`Operation fail:${e.message}`, {
            type: "error",
            anchorOrigin: { vertical: "top", horizontal: "right" },
          }),
      }
    );
  };
  const [state, setState] = useState('#')
  const launchApplicationInvited = ({ applicantid }) => {

    create(
      "loginFromAdminDashboardInvitedApp",
      {
        data: {
          applicantid: applicantid,
        },
      },
      {
        onSuccess: (data) => {

          openWithPopupCheck(data?.records?.launchUrl, "_blank", undefined, {
            onBlocked: notifyPopupBlocked(notify),
          });
          setState(data?.records?.launchUrl);

        },
        onError: (e: any) =>
          notify(`Operation fail:${e.message}`, {
            type: "error",
            anchorOrigin: { vertical: "top", horizontal: "right" },
          }),
      }
    );
  };
  const { data: getUserData } = useGetIdentity();
  const [showApplicantOtherDocuments, setShowApplicantOtherDocuments] = useState(false);
  const isApplicantViewer = isApplicantClassViewer({
    userrole: getUserData?.userrole,
    super_user_role: getUserData?.super_user_role,
    roletype,
  });
  const canShowOtherDocuments = Boolean(getUserData) && !isApplicantViewer;
  const hasExistingOtherDocuments =
    Array.isArray(otherDocumentsData?.other_documents) &&
    otherDocumentsData.other_documents.length > 0;
  const shouldShowApplicantOtherDocumentsPrompt =
    !isGuestCard &&
    Boolean(getUserData) &&
    isApplicantViewer &&
    !otherDocumentsLoading &&
    !hasExistingOtherDocuments;
  const shouldRenderApplicantOtherDocuments =
    !isGuestCard &&
    Boolean(getUserData) &&
    isApplicantViewer &&
    !otherDocumentsLoading &&
    (hasExistingOtherDocuments || showApplicantOtherDocuments);
  const canShowSidebar =
    sidebarOutlineRoot &&
    isActiveTab &&
    isDocuverusSuperAdminUser;
  const closeMoveDrawer = React.useCallback(() => {
    setMoveDrawerOpen(false);
  }, []);
  useEffect(() => {
    document.body.classList.toggle("doc-analysis-move-drawer-open", moveDrawerOpen);
    return () => {
      document.body.classList.remove("doc-analysis-move-drawer-open");
    };
  }, [moveDrawerOpen]);
  const isSidebarOutlineVisible = React.useCallback(() => {
    if (!sidebarOutlineRoot || typeof window === "undefined") return false;
    const style = window.getComputedStyle(sidebarOutlineRoot);
    const rect = sidebarOutlineRoot.getBoundingClientRect();
    return (
      style.display !== "none" &&
      style.visibility !== "hidden" &&
      Number(style.opacity) !== 0 &&
      rect.width > 0 &&
      rect.height > 0 &&
      rect.right > 0 &&
      rect.bottom > 0 &&
      rect.left < window.innerWidth &&
      rect.top < window.innerHeight
    );
  }, [sidebarOutlineRoot]);

  useEffect(() => {
    if (!showApplicantOtherDocuments || !shouldRenderApplicantOtherDocuments) return;

    applicantOtherDocumentsRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
    applicantOtherDocumentsRef.current?.focus({ preventScroll: true });
  }, [showApplicantOtherDocuments, shouldRenderApplicantOtherDocuments]);

  if (
    IncomeAPIResponse?.isLoading &&
    bankDocLoading &&
    otherIncomeDocLoding &&
    proofOfIdsDataLoading &&
    proofOfIdsDataLoading &&
    isLoadingSubscriberConfigurations &&
    sectionPermission.isLoading
  ) {
    return (
      <Grid
        container
        spacing={0}
        direction="column"
        alignItems="center"
        justifyContent="center"
        style={{ minHeight: "100vh" }}
      >
        <Grid item xs={3}>
          <Box sx={{ display: "flex" }}>
            <CircularProgress />
            <h2>&nbsp; Loading...</h2>
          </Box>
        </Grid>
      </Grid>
    );
  }

  if (sectionPermission?.data?.status[3].state == 2 && proofOfIdsData) {
    proof_of_id_section = (
      <ProofOfIdForm
        record={proofOfIdsData}
        setChildFormError={setChildFormError1}
        childFormError={childFormError1}
        ref={poidRef}
        trn_id={proofOfIdsData?.id}
        index={index}
        status={sectionPermission?.data?.status[3].state}
        required={false}
        applicationStatusUpdatedOn={applicantInfo?.applicationStatusUpdatedOn}
      />
    );
  } else if (sectionPermission?.data?.status[3].state == 1 && proofOfIdsData) {
    proof_of_id_section = (
      <ProofOfIdForm
        record={proofOfIdsData}
        ref={poidRef}
        setChildFormError={setChildFormError1}
        childFormError={childFormError1}
        trn_id={proofOfIdsData?.id}
        index={index}
        required={true}
        status={sectionPermission?.data?.status[3].state}
        applicationStatusUpdatedOn={applicantInfo?.applicationStatusUpdatedOn}
      />
    );
  }

  if (sectionPermission?.data?.status[4].state == 2 && proofOfIdsData) {
    proof_of_ssn_section = (
      <SsnAccordion
        record={proofOfIdsData}
        setChildFormError={setChildFormError5}
        childFormError={childFormError5}
        ref={possn}
        Trnid={proofOfIdsData?.id}
        index={index}
        status={sectionPermission?.data?.status[4].state}
        required={false}
        applicationStatusUpdatedOn={applicantInfo?.applicationStatusUpdatedOn}
      />
    );
  } else if (sectionPermission?.data?.status[4].state == 1 && proofOfIdsData) {
    proof_of_ssn_section = (
      <SsnAccordion
        record={proofOfIdsData}
        ref={possn}
        setChildFormError={setChildFormError5}
        childFormError={childFormError5}
        Trnid={proofOfIdsData?.id}
        index={index}
        required={true}
        status={sectionPermission?.data?.status[4].state}
        applicationStatusUpdatedOn={applicantInfo?.applicationStatusUpdatedOn}
      />
    );
  }

  const hasPlaidBankIncomeData =
    Number(validationCheckForPlaidBankIncome?.avgMonthlyIncome) > 0 ||
    (validationCheckForPlaidBankIncome?.banks?.length ?? 0) > 0;
  const hasArgyleBankIncomeData =
    Number(validationCheckForArgyleBankIncome?.avgMonthlyIncome) > 0 ||
    (validationCheckForArgyleBankIncome?.banks?.length ?? 0) > 0;
  const argyleBankOverallStatus = String(
    validationCheckForArgyleBankIncome?.overallStatus || "none"
  ).toLowerCase();
  const hasArgyleBankValidationMessages =
    Array.isArray(validationCheckForArgyleBankIncome?.validation_messages) &&
    validationCheckForArgyleBankIncome.validation_messages.length > 0;
  const shouldShowCombinedBankIncomeSection =
    bankIncomeDepositLinkingEnabled &&
    (plaidBankIncomeEnabled ||
    plaidBankIncomeEnabledError ||
    (plaidBankIncomeEnabled &&
      (plaidBankIncomeValidationLoading || plaidBankIncomeValidationError)) ||
    hasPlaidBankIncomeData ||
    argyleBankIncomeEnabled ||
    argyleBankIncomeEnabledError ||
    ((argyleBankIncomeEnabled || argyleBankPendingHintActive) &&
      (argyleBankIncomeValidationLoading || argyleBankIncomeValidationError)) ||
    hasArgyleBankIncomeData ||
    argyleBankPendingHintActive ||
    argyleBankOverallStatus !== "none" ||
    hasArgyleBankValidationMessages);

  bank_income_section = shouldShowCombinedBankIncomeSection && (
    <div id="bank-income-anchor">
      <span id="plaid-bank-income-anchor" />
      <span id="argyle-bank-income-anchor" />
      <ArgyleBankIncomeSection
        validationCheckForPlaidBankIncome={validationCheckForPlaidBankIncome}
        validationCheckForArgyleBankIncome={validationCheckForArgyleBankIncome}
        className="print-hide"
        trn_id={trn_id}
        plaidEnabled={plaidBankIncomeEnabled}
        plaidEnablementLoading={plaidBankIncomeEnabledLoading}
        plaidEnablementError={plaidBankIncomeEnabledError}
        plaidValidationLoading={plaidBankIncomeValidationLoading}
        plaidValidationError={plaidBankIncomeValidationError}
        enabled={argyleBankIncomeEnabled}
        enablementLoading={argyleBankIncomeEnabledLoading}
        enablementError={argyleBankIncomeEnabledError}
        validationLoading={argyleBankIncomeValidationLoading}
        validationError={argyleBankIncomeValidationError}
        showPendingProcessing={argyleBankPendingHintActive}
        role={userRole}
        required={bankIncomeDepositLinkingMode === "Required"}
        onRetry={() => {
          refetchPlaidBankIncomeEnabled();
          refetchPlaidBankIncomeValidation();
          refetchArgyleBankIncomeEnabled();
          refetchArgyleBankIncomeValidation();
        }}
        onBankRemoved={refetchArgyleBankIncomeValidation}
      />
      <ArgyleBankIncomeSection
        validationCheckForPlaidBankIncome={validationCheckForPlaidBankIncome}
        validationCheckForArgyleBankIncome={validationCheckForArgyleBankIncome}
        className="d-none print-show"
        trn_id={trn_id}
        plaidEnabled={plaidBankIncomeEnabled}
        plaidEnablementLoading={plaidBankIncomeEnabledLoading}
        plaidEnablementError={plaidBankIncomeEnabledError}
        plaidValidationLoading={plaidBankIncomeValidationLoading}
        plaidValidationError={plaidBankIncomeValidationError}
        enabled={argyleBankIncomeEnabled}
        enablementLoading={argyleBankIncomeEnabledLoading}
        enablementError={argyleBankIncomeEnabledError}
        validationLoading={argyleBankIncomeValidationLoading}
        validationError={argyleBankIncomeValidationError}
        showPendingProcessing={argyleBankPendingHintActive}
        role={userRole}
        required={bankIncomeDepositLinkingMode === "Required"}
        onRetry={() => {
          refetchPlaidBankIncomeEnabled();
          refetchPlaidBankIncomeValidation();
          refetchArgyleBankIncomeEnabled();
          refetchArgyleBankIncomeValidation();
        }}
      />
    </div>
  );

  if (employmentDocumentSection.visible && IncomeAPIResponse.data) {
    proof_of_income_section = (
      <ProofOfEmploymentIncome
        role={userRole}
        ref={poincome}
        setChildFormError={setChildFormError2}
        childFormError={childFormError2}
        index={index}
        status={employmentDocumentSection.state}
        IncomeAPIResponse={IncomeAPIResponse}
        LookbacksData={getlookbacks?.data}
        required={employmentDocumentSection.required}
        grossValue={handleGrossvalue}
        payrollPlaidEnabled={payrollLinkingUiEnabled}
        payrollValidationLoading={plaidPayrollLoading || argylePayrollLoading}
        payrollEmployers={payrollEmployers}
        payrollSourceStatuses={validationCheckForPlaidPayrollIncome?.payrollSourceStatuses}
        argyleSourceStatuses={validationCheckForArgylePayrollIncome?.argyleSourceStatuses}
        applicationStatusUpdatedOn={applicantInfo?.applicationStatusUpdatedOn}
        argylePayrollValidationMessages={validationCheckForArgylePayrollIncome?.validation_messages}
      />
    );
  }

  if (
    sectionPermission?.data?.status[2].state == 2 &&
    otherIncomeData?.other_income_details
  ) {
    other_income_section = (
      <ProofOfNonEmploymentSection
        record={otherIncomeData?.other_income_details}
        setChildFormError={setChildFormError3}
        childFormError={childFormError3}
        ref={po_other_income}
        index={index}
        status={sectionPermission?.data?.status[2].state}
        required={false}
        trn_id={otherIncomeData.trn_id}
      />
    );
  } else if (
    sectionPermission?.data?.status[2].state == 1 &&
    otherIncomeData?.other_income_details
  ) {
    other_income_section = (
      <ProofOfNonEmploymentSection
        setChildFormError={setChildFormError3}
        childFormError={childFormError3}
        record={otherIncomeData?.other_income_details}
        ref={po_other_income}
        index={index}
        trn_id={otherIncomeData.trn_id}
        required={true}
        status={sectionPermission?.data?.status[2].state}
      />
    );
  }

  if (bankingDocumentSection.visible && bankData?.banking_details) {
    bank_section = (
      <BankStatements
        record={bankData?.banking_details}
        trn_id={bankData.trn_id}
        LookbacksData={getlookbacks?.data}
        ref={po_banking}
        required={bankingDocumentSection.required}
        setChildFormError={setChildFormError4}
        childFormError={childFormError4}
        index={index}
        status={bankingDocumentSection.state}
        isFetching={isFetching}
        applicationStatusUpdatedOn={applicantInfo?.applicationStatusUpdatedOn}
      />
    );
  }

  const shouldRenderOtherDocuments =
    !isGuestCard &&
    ((canShowOtherDocuments &&
      (getUserData?.userrole === typesofUsers?.landlordThirdPartyAgent
        ? isSuperAdmin(
            checkModuleAccess(
              permissions,
              "Income & Banking Tab",
              "View Other Docs"
            ),
            getUserData?.userrole
        )
        : true)) ||
      shouldRenderApplicantOtherDocuments);

  const outlineItems = buildSubmissionOutlineItems({
    includeProofOfId: Boolean(proof_of_id_section),
    includeProofOfSsn: Boolean(proof_of_ssn_section),
    includeEmployment: Boolean(proof_of_income_section),
    includeOtherIncome: Boolean(other_income_section),
    includePlaidBankIncome: Boolean(shouldShowCombinedBankIncomeSection),
    includeBankStatements: Boolean(bank_section),
    includeOtherDocuments: Boolean(shouldRenderOtherDocuments),
    idSectionData,
    ssnSectionData,
    idSectionSocrStatus,
    ssnSectionSocrStatus,
    hasSsnSectionDocumentContext,
    employerSources,
    getEmployerSourceStatus,
    payrollEmployerNameBySource,
    otherIncomeData,
    plaidBankIncomeSources,
    plaidBankIncomeValidationLoading,
    validationCheckForPlaidBankIncome,
    bankData,
    bankValidationCheck: validationCheck,
    record,
    applicationStatusUpdatedOn: applicantInfo?.applicationStatusUpdatedOn,
    sectionAvailability: sectionAvailabilityData,
  });

  // Bulk move/delete only makes sense when the submission outline has reviewable
  // sections to act on. A brand-new VR has no document sections, so outlineItems
  // is empty and the bulk buttons stay hidden even for super admins (the outline
  // panel itself still renders for super admins via canShowSidebar).
  // The applicant-facing docupload view never gets bulk actions, even when a
  // super admin opens it in their own session (e.g. starting a VR from the New
  // button) — isApplicantViewer checks the view's roletype, not just identity.
  const canUseBulkDocumentActions =
    ENABLE_BULK_DOCUMENT_MOVE_DELETE &&
    getUserData?.userrole === typesofUsers.docuverusSuperAdmin &&
    !isApplicantViewer &&
    outlineItems.length > 0;

  const renderSubmissionOutlineNavigation = (options?: { disableNavigationInMoveMode?: boolean }) => (
    <SubmissionOutlineNavigation
      items={outlineItems}
      propertyName={
        record?.Property ||
        applicantDetails?.office_property_name ||
        applicantDetails?.property_name ||
        null
      }
      appId={record?.AppID || applicantDetails?.application_id || null}
      applicantName={
        record?.ApplicantList ||
        `${applicantDetails?.first_name || ""} ${applicantDetails?.last_name || ""}`.trim()
      }
      applicantType={
        record?.ApplicantType ||
        applicantDetails?.ApplicantType ||
        applicantDetails?.applicant_type ||
        "Applicant"
      }
      applicationStatus={mapApplicationStatusToOutlineStatus(applicantStatusKey)}
      applicationStatusTooltip={getApplicationStatusTooltip(applicantStatusKey)}
      canNavigatePrevTab={index > 0}
      canNavigateNextTab={index + 1 < totalApplicationCount}
      onNavigatePrevTab={onNavigatePrevTab}
      onNavigateNextTab={onNavigateNextTab}
      deletedDocCount={deletedDocCount}
      onOpenDeletedDocs={handleopendeleteddocs}
      canUseBulkDocumentActions={canUseBulkDocumentActions}
      contentRootId={outlineContentRootId}
      loading={
        sectionPermission.isLoading ||
        proofOfIdsDataLoading ||
        IncomeAPIResponse?.isLoading ||
        bankDocLoading ||
        otherIncomeDocLoding
      }
      disableNavigationInMoveMode={options?.disableNavigationInMoveMode}
    />
  );

  const wrapOutlineSection = (anchorId: string, section: any) =>
    section ? (
      <div id={anchorId} className="submission-outline-anchor">
        {section}
      </div>
    ) : (
      section
    );

  proof_of_id_section = wrapOutlineSection("submission-proof-of-id", proof_of_id_section);
  proof_of_ssn_section = wrapOutlineSection("submission-proof-of-ssn", proof_of_ssn_section);
  proof_of_income_section = wrapOutlineSection("submission-proof-of-employment", proof_of_income_section);
  other_income_section = wrapOutlineSection("submission-proof-of-other-income", other_income_section);
  bank_section = wrapOutlineSection("submission-bank-statements", bank_section);

  const onClickViewAppHandler = async (event) => {
    if (isLoadingViewApp) return;
    const payloadData = {
      applicationNumber: record?.AppID,
      applicantID: record?.id,
    };
    setIsLoading(true);
    try {
      const viewAppReport = await dataProvider.getOne("viewappreport", {
        id: payloadData,
      });
      openWithPopupCheck(`${viewAppReport?.data?.data}`, "_blank", undefined, {
        onBlocked: notifyPopupBlocked(notify),
      });
    } catch (error: any) {
      notify(error?.message || "Failed to open application report", {
        type: "warning",
        anchorOrigin: { vertical: "top", horizontal: "right" },
      });
    } finally {
      setIsLoading(false);
    }
  };

  // Which permission module gates View/Print Result for each application type.
  const PRINT_PERMISSION_MODULE_BY_APP_TYPE = {
    "Application Invite": "Inbox",
    "Doc Upload": "Doc Upload App",
    "Guest Card": "Guest Card App",
  };
  const printPermissionModule =
    PRINT_PERMISSION_MODULE_BY_APP_TYPE[
      applicantData?.Application_details?.application_type
    ];
  const canShowSubmittedReport = isExistingVrResultVisible(
    data?.ApplicationStatus,
    record?.Score ?? data?.Score,
    record?.ApplicantStatus,
    record?.HasPreservedScreeningReport
  );

  // ADO 4855: opens the Generate Report Options / Report Options menu
  // (content mode + preview/download) for the official, immutable record
  // captured at the most recent submission. Its PDF is rendered fresh on
  // every view.
  const onClickViewSubmittedReportHandler = (
    event: React.MouseEvent<HTMLElement>
  ) => {
    setVrReportMenuAnchorEl(event.currentTarget);
  };

  const handleReview = async () => {
    create(
      "updatereviewdone",
      {
        data: {
          applicationnumber: record?.AppID,
        },
      },
      {
        onSuccess: (data) => {
          notify(`Review done successfully.`, {
            type: "success",
            anchorOrigin: { vertical: "top", horizontal: "right" },
          });
          openpanel.track("ats_application_review_done", {
            applicationNumber: telemetryApplicationNumber,
            applicantId: telemetryApplicantId || null,
            applicationType: "ATS",
            subscriberId: record?.SubscriberID || data?.SubscriberID || null,
            trnId: trn_id || null,
          });

          clearNewTagsImmediately();
          if (
            reportApplicationType === "ATS" &&
            reviewDoneFraudReporting?.reportFraudForReviewDoneApplicants
          ) {
            reviewDoneFraudReporting.reportFraudForReviewDoneApplicants();
          } else {
            triggerReportFraudApplicant("15");
          }
        },
        onError: (e: any) =>
          notify(`Operation fail:${e.message}`, {
            type: "error",
            anchorOrigin: { vertical: "top", horizontal: "right" },
          }),
      }
    );
  };
  return (
    <>
      <ApplicantContext.Provider value={{ applicantInfo, setApplicantInfo }}>
        <DocumentMoveProvider
          trnId={trn_id}
          bulkActionsEnabled={canUseBulkDocumentActions}
          isMoveDestinationVisible={isSidebarOutlineVisible}
          onRequestMoveFallback={() => setMoveDrawerOpen(true)}
          onMoveFallbackClose={closeMoveDrawer}
        >
        <TabClearer isActiveTab={isActiveTab} />
        {/* While the move drawer is open it renders its own copy of the
            outline; suppress the sidebar portal copy so the outline (and its
            anchor element IDs) is never mounted twice at once. */}
        {canShowSidebar && !moveDrawerOpen
          ? createPortal(renderSubmissionOutlineNavigation(), sidebarOutlineRoot)
          : null}
        <Drawer
          anchor="left"
          open={moveDrawerOpen}
          onClose={closeMoveDrawer}
          PaperProps={{ className: "document-move-drawer-paper" }}
        >
          <div className="document-move-drawer-header">
            <span>Move Documents</span>
            <IconButton
              aria-label="Close move drawer"
              onClick={closeMoveDrawer}
              size="small"
            >
              <CloseIcon style={{ fontSize: "14px" }} />
            </IconButton>
          </div>
          {moveDrawerOpen ? renderSubmissionOutlineNavigation({ disableNavigationInMoveMode: true }) : null}
        </Drawer>
        <Dialog
          open={deleteddocs}
          onClose={handleclosedeleteddocs}
          fullWidth
          sx={{
            "& .MuiDialog-container.MuiDialog-scrollPaper .MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation24.MuiDialog-paper":
              { maxWidth: 900 },
          }}
        >
          <DialogTitle
            sx={{ m: 0, p: 1, backgroundColor: "Gainsboro" }}
            id="customized-dialog-title"
          >
            Deleted documents
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={handleclosedeleteddocs}
            sx={{
              position: "absolute",
              right: 6,
              top: 1,

              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon style={{ fontSize: "12px" }} />
          </IconButton>
          <DialogContent>
            <Resource
              name="deletedDocument"
              list={DeletedDocsList}
            />
          </DialogContent>
        </Dialog>

        <section className="main-sec">
          <div id={outlineContentRootId}>
          {appHeaderRequired && (
            <ApplicationHeader
              role={userRole}
              subscriberId={proofOfIdsData?.applicant?.SubscriberID}
              subscriberData={subscriberData}
              applicantName={`${applicantDetails?.first_name} ${applicantDetails?.last_name}`}
              onLogout={() => {
                if (shouldProtectLeave) {
                  queueLeaveAction(() => {
                    localStorage.removeItem("auth");
                  });
                } else {
                  localStorage.removeItem("auth");
                }
                navigation("/ats");
              }}
            />
          )}
          <div ref={exportRef} className="basic-info">
            <div className="d-flex flex-wrap mb-2">

              <div className="basic-subinfo px-2">
                <div className="info-block">
                  <label htmlFor="">App ID.</label>
                </div>
                <span>
                  {applicantDetails?.application_id
                    ? applicantDetails?.application_id
                    : ""}
                </span>
              </div>
              <div className="basic-subinfo px-2">
                <div className="info-block">
                  <label htmlFor="">Trn ID</label>
                </div>
                <span>{trn_id ? trn_id : ""}</span>
              </div>
              <div className="basic-subinfo px-2">
                <div className="info-block">
                  <label htmlFor="">Name</label>

                  <button
                    className="print-hide"
                    type="button"
                    data-bs-toggle="modal"
                    data-bs-target="#namechange"
                    onClick={handleOpen}
                    disabled={(getUserData?.userrole == typesofUsers.landlordThirdPartyAgent) ? true : false}
                  >
                    <img src={pencilIcon} alt="" />
                  </button>

                </div>
                <span
                  title={`${applicantDetails?.first_name} ${applicantDetails?.last_name}  `}
                  style={{
                    maxWidth: "150px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    display: "inline-block",
                  }}
                >
                  {`${applicantDetails?.first_name} ${applicantDetails?.last_name}  `}
                </span>
              </div>
              <div className="basic-subinfo px-2">
                <div className="info-block">
                  <label htmlFor="">Mobile Phone</label>

                  <button
                    className="print-hide"
                    type="button"
                    data-bs-toggle="modal"
                    data-bs-target="#namechange"
                    onClick={handleOpen}
                    disabled={(getUserData?.userrole == typesofUsers.landlordThirdPartyAgent) ? true : false}
                  >
                    <img src={pencilIcon} alt="" />
                  </button>

                </div>
                <span>
                  {applicantDetails?.mobile
                    ? applicantDetails?.country_code + applicantDetails?.mobile
                    : "NA"}
                </span>
              </div>
              <div className="basic-subinfo px-2">
                <div className="info-block">
                  <label htmlFor="">Email</label>
                  <button
                    className="print-hide"
                    type="button"
                    data-bs-toggle="modal"
                    data-bs-target="#namechange"
                    onClick={handleOpen}
                    disabled={(getUserData?.userrole == typesofUsers.landlordThirdPartyAgent) ? true : false}
                  >
                    <img src={pencilIcon} alt="" />
                  </button>

                </div>
                <span
                  title={applicantDetails?.email}
                  style={{
                    maxWidth: "150px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    display: "inline-block",
                  }}
                >
                  {applicantDetails?.email}
                </span>
              </div>

              <div className="basic-subinfo px-2">
                <div className="info-block">
                  <label htmlFor="">Date</label>
                </div>
                <span>
                  {localStorage.getItem("createdDateAsPerClientRequest") ? (
                    localStorage.getItem("createdDateAsPerClientRequest")
                  ) : (
                    <DateComponent date={applicantDetails?.creataed_on} />
                  )}
                </span>
              </div>
              <div className="basic-subinfo px-2">
                <div className="info-block">
                  <label htmlFor="">Property/Office Name</label>
                </div>
                <span>
                  {applicantDetails?.office_property_name
                    ? applicantDetails?.office_property_name
                    : ""}
                </span>
              </div>
              <div className="basic-subinfo px-2">
                <div className="info-block">
                  <label htmlFor="">User Name</label>
                </div>

                <span
                  title={applicantDetails?.UserName}
                  style={{
                    maxWidth: "150px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    display: "inline-block",
                  }}
                >
                  {applicantDetails?.UserName
                    ? applicantDetails?.UserName
                    : "NA"}
                </span>
              </div>

              {printPermissionModule &&
                userRole !== "applicant" &&
                canShowSubmittedReport &&
                isSuperAdmin(checkModuleAccess(permissions, printPermissionModule, "View Report"), getUserData?.userrole) && (
                  <div className="basic-subinfo px-2">
                    <div className="modal-sm-button">
                      <button
                        onClick={onClickViewSubmittedReportHandler}
                        type="button"
                        className="p-0 mt-0 print-hide"
                        style={{ lineHeight: "22px" }}
                      >
                        <BiSolidFilePdf size={16} />
                        <br />
                        <span> View/Print Result</span>
                      </button>
                      <VrReportOptionsMenu
                        trnId={trn_id}
                        anchorEl={vrReportMenuAnchorEl}
                        onClose={() => setVrReportMenuAnchorEl(null)}
                      />
                    </div>
                  </div>
                )}


              {applicantData?.Application_details?.application_type !== "Guest Card" &&
                userRole !== "applicant" &&
                (
                  <div className="basic-subinfo px-2">
                    <div className="modal-sm-button">
                      <button
                        type="button"
                        className="p-0 mt-0 print-hide"
                        data-bs-toggle="modal"
                        data-bs-target="#exampleModal"
                        onClick={() => {
                          downloadZip(record?.id || id);
                        }}
                        style={{ lineHeight: "22px" }}
                        disabled={isDownloading} // Add a disabled state
                      >
                        {isDownloading ? ( // Add a loader
                          <Box sx={{ display: "flex" }}>
                            <CircularProgress size="25px" />
                          </Box>
                        ) : (
                          <>
                            <BiSolidFileArchive size={16} /> <br />
                            <span> Download Documents</span>
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                )}

              {applicantData?.Application_details?.application_type !=
                "Doc Upload" && !(getUserData?.userrole == typesofUsers.landlordThirdPartyAgent) && (
                  <div className="basic-subinfo px-2 print-hide">
                    <div className="modal-sm-button">
                      <ShowNotesModal record={record} />
                    </div>
                  </div>
                )}

              {isSuperAdmin(checkModuleAccess(permissions, "Inbox", "Screening Report"), getUserData?.userrole) && applicantData?.Application_details?.application_type ==
                "Application Invite" &&
                userRole !== "applicant" &&
                isScreeningReportActionVisible(
                  applicantData?.Application_details?.application_status,
                  record?.Score,
                  data?.ApplicationStatus,
                  getUserData?.userrole,
                  record?.HasPreservedScreeningReport ?? data?.HasPreservedScreeningReport
                ) && (
                  <div className="basic-subinfo px-2">
                    <div className="modal-sm-button">
                      <button
                        type="button"
                        className="p-0 mt-0"
                        data-bs-toggle="modal"
                        data-bs-target="#exampleModal"
                        onClick={(event) => onClickScreeningReport(event, data, record)}
                        style={{ lineHeight: "22px" }}
                      >
                        <FaBook size={16} />
                        <ReportReprocessingIndicator
                          active={record?.HasPreservedScreeningReport ?? data?.HasPreservedScreeningReport}
                          iconOnly
                        />
                        <br />
                        <span>Screening Report</span>
                      </button>
                    </div>
                  </div>
                )}
              {appType == "1" && isSuperAdmin(checkModuleAccess(permissions, "Inbox", "View Adverse Letter"), getUserData?.userrole) &&
                data?.ApplicationStatus !== "Invited" &&
                data?.ApplicationStatus !== "Application In Progress" &&
                data?.ApplicationStatus !== "Submitted" &&
                data?.ApplicationStatus !== "Review Pending" &&
                data?.ApplicationStatus !== "Cancelled" &&
                data?.ApplicationStatus !== "Completed-Approved" &&
                data?.ApplicationStatus !== "Archived" &&
                data?.ApplicationStatus !== "Screening" && !(getUserData?.userrole == typesofUsers.landlordThirdPartyAgent) && (
                  <div className="basic-subinfo px-2">
                    <div className="modal-sm-button">
                      <button
                        onClick={() => { navigate('/ats/adverseletter', { state: { SubscriberID: id, ...data, applicantId: record?.id } }) }}
                        type="button"
                        className="p-0 mt-0 print-hide"
                        style={{ lineHeight: "22px" }}
                      >
                        <FaRegNoteSticky style={{ fontSize: "16px" }} />
                        <br />
                        <span>View Adverse Letter</span>
                      </button>
                    </div>
                  </div>
                )}

              <div className="basic-subinfo print-hide px-2">
                <div className="modal-sm-button">
                  {isSuperAdmin(checkModuleAccess(permissions, "View Docs", ""), getUserData?.userrole) && userRole !== "applicant" && (
                    <button
                      type="button"
                      className="p-0 mt-0"
                      data-bs-toggle="modal"
                      data-bs-target="#exampleModal"
                      onClick={(event) => onClickDocsHandler(event, applicantData)}
                      style={{ lineHeight: "22px" }}
                    >
                      <img src={img1} alt="" /> <br />
                      <span>View Docs</span>
                    </button>
                  )}
                </div>
              </div>

              {

                userRole !== "applicant" &&
                record?.ApplicantStatus !== "Cancelled" &&
                record?.ApplicantStatus !== "Archieved" &&
                record?.ApplicantStatus == "Submitted" &&
                appType == "1" && isSuperAdmin(checkModuleAccess(permissions, "Inbox", "View Application"), getUserData?.userrole) &&

                (
                  <div className="basic-subinfo px-2">
                    <div className="modal-sm-button">

                      <button
                        type="button"
                        className="p-0 mt-0"
                        data-bs-toggle="modal"
                        data-bs-target="#exampleModal"
                        disabled={isLoadingViewApp}
                        onClick={(event) => onClickViewAppHandler(event)}
                        style={{ lineHeight: "22px" }}
                      >
                        {isLoadingViewApp ? (
                          <Box sx={{ display: "flex" }}>
                            <CircularProgress size="25px" />
                          </Box>
                        ) : (
                          <>
                            <PictureAsPdfIcon /> <br />
                            <span>View App</span>
                          </>
                        )}
                      </button>
                    </div>
                  </div>

                )
              }
              {userRole != "applicant" && !(getUserData?.userrole == typesofUsers.landlordThirdPartyAgent) && (
                <div className="basic-subinfo px-2 print-hide">
                  <div className="modal-sm-button">
                    <AuditlogModal
                      record={{
                        AppID: applicantDetails?.application_id,
                        id,
                        trn_id: record?.Trnid,
                      }}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>

          <div
            className={`info-toggle-wrap${
              appFooterRequired ? " info-toggle-wrap--with-app-footer" : ""
            }`}
          >
            <div className="subheaders">
              {proofOfIdsData?.applicant?.thirdPartyAppName != null && (
                <>
                  {userRole !== "applicant" && (
                    <div>
                      {proofOfIdsData?.applicant?.interactionType == "Received"
                        ? " Received from "
                        : " Sent to "}
                      {proofOfIdsData?.applicant?.thirdPartyAppName}
                    </div>
                  )}
                </>
              )}
              {appType == "1" && (
                <>
                  {" "}
                  {!(Number(record?.ApplicationCompleted) > 79) && (
                    <div className="alert alert-danger" role="alert">
                      App Status:'{record?.ApplicantStatus}'.
                      {location?.state?.isAppCreatedUsingNet &&
                        "This app has been created using an older system and is currently in view-only mode."}
                      {!location?.state?.isAppCreatedUsingNet && (
                        <>
                          {" "}
                          It is currently in view-only mode.{" "}
                          <a
                            onClick={(e) => {
                              e.preventDefault();
                              record.ApplicantStatus == "Invited"
                                ? launchApplicationInvited({
                                  applicantid: record.id,
                                })
                                : launchApplication({
                                  username: record.UserName || record.Email,
                                  applicantId: record.id,
                                  applicationNumber: record.AppID || applicationId,
                                  subscriberId: record.SubscriberID,
                                });
                            }}
                            href="#"
                            className="alert-link"
                          >
                            Click here
                          </a>


                          <span> to open the application.</span>
                        </>
                      )}
                    </div>
                  )}
                </>
              )}
            </div>

            {shouldShowRiskFlag && (
              <div style={{ marginBottom: "12px" }}>
                <RiskFlagAlert
                  isFraudRiskMatch
                  className="print-hide"
                  applicant={riskMatchApplicant}
                />
              </div>
            )}

            {!toggleDetails && isOpeningForDashboard && (
              <PersonalDetailsAccordion Trnid={record?.Trnid} />
            )}

            {
              roletype === "docupload_applicant"
                ? proof_of_id_section
                : getUserData?.userrole === typesofUsers?.landlordThirdPartyAgent && isSuperAdmin(checkModuleAccess(permissions, "Identification Tab", "View Proof of Identity"), getUserData?.userrole)
                  ? proof_of_id_section
                  : (applicantData?.Application_details?.application_type == "Application Invite" || appType == "1") && getUserData?.userrole != typesofUsers?.landlordThirdPartyAgent && isSuperAdmin(checkModuleAccess(permissions, "Inbox", "View PII"), getUserData?.userrole)
                    ? proof_of_id_section
                    : (applicantData?.Application_details?.application_type == "Doc Upload" || appType == "2") && getUserData?.userrole != typesofUsers?.landlordThirdPartyAgent && isSuperAdmin(checkModuleAccess(permissions, "Doc Upload App", "View PII"), getUserData?.userrole)
                      ? proof_of_id_section
                      : (applicantData?.Application_details?.application_type == "Guest Card" || appType == "3") && getUserData?.userrole != typesofUsers?.landlordThirdPartyAgent
                        ? proof_of_id_section
                        : ""

            }



            {roletype === "docupload_applicant"
              ? proof_of_ssn_section
              : ((!toggleDetails && isOpeningForDashboard) || data?.appInDAReviewQueue) && (getUserData?.userrole === typesofUsers?.landlordThirdPartyAgent && isSuperAdmin(checkModuleAccess(permissions, "Identification Tab", "View SSN"), getUserData?.userrole))
                ? proof_of_ssn_section //<SsnAccordion Trnid={record?.Trnid} />
                : (applicantData?.Application_details?.application_type == "Application Invite" || appType == "1") && getUserData?.userrole != typesofUsers?.landlordThirdPartyAgent && isSuperAdmin(checkModuleAccess(permissions, "Inbox", "View PII"), getUserData?.userrole)
                  ? proof_of_ssn_section
                  : (applicantData?.Application_details?.application_type == "Doc Upload" || appType == "2") && getUserData?.userrole != typesofUsers?.landlordThirdPartyAgent && isSuperAdmin(checkModuleAccess(permissions, "Doc Upload App", "View PII"), getUserData?.userrole)
                    ? proof_of_ssn_section
                    : ""
            }

            {!toggleDetails && isOpeningForDashboard && isSuperAdmin(checkModuleAccess(permissions, "Identification Tab", "View Address"), getUserData?.userrole) &&
              (
                <AddressAccordion Trnid={record?.Trnid} />
              )}
            {!toggleDetails && isOpeningForDashboard && (
              <>
                <ApplicantDetailsAccordion Trnid={record?.Trnid} />
              </>
            )}

            {getUserData?.userrole === typesofUsers?.landlordThirdPartyAgent && isSuperAdmin(checkModuleAccess(permissions, "Income & Banking Tab", "View Proof of Employment"), getUserData?.userrole)
              ? proof_of_income_section
              : !isGuestCard
                ? proof_of_income_section
                : ""
            }
            {getUserData?.userrole === typesofUsers?.landlordThirdPartyAgent && isSuperAdmin(checkModuleAccess(permissions, "Income & Banking Tab", "View Other Income"), getUserData?.userrole)
              ? other_income_section
              : !isGuestCard
                ? other_income_section
                : ""
            }
            {getUserData?.userrole === typesofUsers?.landlordThirdPartyAgent && isSuperAdmin(checkModuleAccess(permissions, "Income & Banking Tab", "View Plaid Bank Income"), getUserData?.userrole)
              ? bank_income_section
              : !isGuestCard
                ? bank_income_section
                : ""
            }
            {getUserData?.userrole === typesofUsers?.landlordThirdPartyAgent && isSuperAdmin(checkModuleAccess(permissions, "Income & Banking Tab", "View Plaid Bank Income"), getUserData?.userrole)
              ? plaid_payroll_income_section
              : !isGuestCard
                ? plaid_payroll_income_section
                : ""
            }

            {getUserData?.userrole === typesofUsers?.landlordThirdPartyAgent && isSuperAdmin(checkModuleAccess(permissions, "Income & Banking Tab", "View Banking Information"), getUserData?.userrole)
              ? bank_section
              : !isGuestCard
                ? bank_section
                : ""
            }
            {shouldShowApplicantOtherDocumentsPrompt || shouldRenderOtherDocuments ? (
              <div id="submission-other-documents" className="submission-outline-anchor">
                {shouldShowApplicantOtherDocumentsPrompt ? (
                  <p>
                    <span>
                      Need to upload any other documents besides pay stubs, proof of non-employment income, or bank statements?
                    </span>{" "}
                    <button
                      type="button"
                      aria-expanded={showApplicantOtherDocuments}
                      aria-controls="submission-other-documents"
                      className="btn btn-link p-0 align-baseline"
                      onClick={() => setShowApplicantOtherDocuments(true)}
                    >
                      Click here
                    </button>{" "}
                    to upload additional documents.
                  </p>
                ) : null}
                {shouldRenderOtherDocuments ? (
                  <div ref={applicantOtherDocumentsRef} tabIndex={-1}>
                    <OtherDocuments Trnid={record?.Trnid} />
                  </div>
                ) : null}
              </div>
            ) : ""}
          </div>
          {data?.appInDAReviewQueue && (
            <button
              className="btn btn-info me-md-2"
              type="button"
              style={{
                backgroundColor: "rgb(45, 195, 232)",
                color: "white",
                padding: "5px 8px 5px 8px",
                marginLeft: "5px",
                fontFamily: "OpenSans-Bold",
                border: "0",
                marginBottom: 10,
              }}
              onClick={handleReview}
            >
              Review Done
            </button>
          )}

          {data?.appInDAReviewQueue &&
            getUserData?.userrole === typesofUsers.docuverusSuperAdmin &&
            sendMessageRecipients.length > 0 && (
              <SendEmailToApplicant
                record={sendMessageRecipients}
                trn_id={trn_id}
                buttonVariant="outlined"
                prefillMessage={applicantValidationPrefill}
              />
            )}


          <br />
          <br />
          {((appType !== "1" &&
            userRole === "Docuverus Super Admin" &&
            applicantData?.Application_details?.application_status == 5) ||
            ((appType == "2" || appType == "3") &&
              userRole === "Docuverus Super Admin") ||
            (userRole !== "applicant" && appType !== "1")) && !data?.appInDAReviewQueue ? (
            <FormProvider {...methods}>

              <form onSubmit={methods.handleSubmit(handle_Admin_Submit)}>
                <div id="submission-application-status" className="print-hide submission-outline-anchor">
                  <div className="row align-items-end gx-2 pb-3">
                    {userRole == "Docuverus Super Admin" &&
                      <div className="col-md-3 col-sm-12">


                        <SelectInput
                          label="Application Status"
                          source={`application_status`}
                          options={
                            appType == "1"
                              ? [
                                { name: "Review Pending", value: "5" },
                              ]
                              : userRole !== "Docuverus Super Admin"
                                ? [{ name: "Review Pending", value: "5" }]
                                : [
                                  { name: "Verified", value: "13" },
                                  {
                                    name: "Further Documentation Required",
                                    value: "14",
                                  },
                                  { name: "Unverifiable", value: "15" },
                                ]
                          }
                          required={false}
                          extraClass={"application_status_style"}
                        />
                      </div>}

                    <div className="col-md-9 col-sm-12">
                      <div className="gap-2 d-sm-flex align-items-end flex-wrap">
                        <button
                          className="btn btn-primary me-md-2"
                          type="submit"
                          disabled={updateApplicantStatus.isLoading}
                          style={{
                            backgroundColor: "rgb(45, 195, 232)",
                            color: "white",
                            padding: "5px 8px 5px 8px",
                            fontFamily: "OpenSans-Bold",
                            border: "0"
                          }}
                        >
                          Submit
                        </button>
                        {userRole === "Docuverus Super Admin" &&
                          sendMessageRecipients.length > 0 && (
                            <SendEmailToApplicant
                              record={sendMessageRecipients}
                              trn_id={trn_id}
                              buttonVariant="outlined"
                              prefillMessage={applicantValidationPrefill}
                            />
                          )}
                        {userRole === "Docuverus Super Admin" &&
                          canShowResendInvite &&
                          resendInviteApplicationNumber &&
                          resendInviteSubscriberId &&
                          resendInviteRecord && (
                            <ResendInvite
                              record={resendInviteRecord}
                              ApplicationNumber={resendInviteApplicationNumber}
                              subscriberId={resendInviteSubscriberId}
                              buttonVariant="outlined"
                            />
                          )}

                        {appFooterRequired && (
                          <>
                            {userRole == "Docuverus Super Admin" && (
                              <AlertDialogTable trn_id={trn_id} />
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </FormProvider>
          ) : (
            <></>
          )}

          {appFooterRequired && (
            <>
              {userRole !== "applicant" && (
                <div className="d-flex justify-content-between align-items-end">
                  <div></div>
                </div>
              )}
              {userRole === "applicant" && (
                <ApplicantFooter
                  showPrevNext={totalApplicationCount > 1}
                  isFirst={index === 0}
                  isLast={(index + 1) === totalApplicationCount}
                  onPrev={navigateToPrevTab}
                  onNext={handleFormSubmitNext}
                  onSubmit={handleFormSubmit}
                  submitButtonRef={submitButnRef}
                />
              )}
              <Confirm
                isOpen={isLeavePromptOpen}
                sx={{
                  "& .RaConfirm-iconPaddingStyle": { display: "none" },
                }}
                title="Leave this application?"
                content="Your progress is saved, but this ATS Application or VR is still In Progress and has not been submitted."
                confirm="Leave"
                cancel="Stay"
                onConfirm={confirmLeave}
                onClose={cancelLeave}
              />
            </>
          )}
          {roletype != "docupload_admin" &&
            roletype !== "docupload_applicant" &&
            appType === "1" && <GrayStripeBar data={data} />}
          </div>
        </section>
        <NameChangeModal
          trn_id={proofOfIdsData?.id}
          first_name={applicantDetails?.first_name}
          last_name={applicantDetails?.last_name}
          mobile={applicantDetails?.mobile}
          email={applicantDetails?.email}
          country_code={applicantDetails?.country_code}
          fetchRecord={() => refetch()}
          handleClose={handleClose}
          open={open}
        />
        </DocumentMoveProvider>
      </ApplicantContext.Provider>
    </>
  );
};

const DocumentAnalysisShow = (props: DocumentAnalysisShowProps) => (
  <QuickLookProvider>
    <DocumentAnalysisContent {...props} />
  </QuickLookProvider>
);

export default DocumentAnalysisShow;
